import React, { useState, useEffect } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import toast from "react-hot-toast";
// import { useNavigate } from "react-router-dom";

//API
import ItemService from "../../../services/supplier_appCommonService";

//Redux
import { useSelector } from "react-redux"; //useDispatch
// import {
//   getSupplierCategorySelection,
//   getSupplierList,
// } from "../../../../redux/feature/supplier_app/supplierSlice";
// import { getLoginUserData } from "../../../../redux/feature/userSlice";
// import { addCategorySelectedData } from "../../../../redux/feature/supplier_app/supplierSlice";

//Components
import Layout from "../../../Layout/Layout";
import { InputField } from "../../../Components/formElements/InputField";
import { ComboboxField } from "../../../Components/formElements/ComboboxField";
import CategorySelectionModal from "../../../Components/Modal/supplier_app/CategorySelectionModal";
import DataTable from "react-data-table-component";
import Constants from "../../../common/SupplierConstants";
import CommonFillter from "../../../Components/Filter/Supplier/SupplierCommonFillter";
import ShowHorizontalStatus from "../../../Components/Modal/supplier_app/Workflow/ShowHorizontalStatus";
import FileViewerModal from "../../../Components/FileViewer/FileViewerModal";
import { ComboboxFieldSubArray } from "../../../Components/formElements/ComboboxFieldSubArray";
import FileUploadComponent from "../../../Components/formElements/FileUploadComponent";
import { TextAreaField } from "../../../Components/formElements/TextAreaField";
// import FileUploadComponent from "../../../Components/formElements/FileUploadComponent";

const VendorDetailedPage = () => {
  // const navigate = useNavigate();
  // const dispatch = useDispatch();
  localStorage.setItem("menu", "Vendor");
  localStorage.setItem("submenu", "Vendor List");

  // let selectedCategoryData = useSelector(
  //   (state) => state?.supplier?.selectedCategory
  // ); // User Details from Store
  let userInfo = useSelector((state) => state?.user?.data); // User Details from Store
  // let supplierData = useSelector((state) => state?.supplier?.data); // User Details from Store
  let supplierID = useSelector((state) => state?.supplier?.supplierID); // User Details from Store
  let config = useSelector((state) => state?.common?.data?.workflow); // config Details from Store
  let workflow = useSelector((state) => state?.supplier?.workflow); // workflow from Store

  let dropdownOption = [
    {
      id: "1",
      name: "Yes",
    },
    {
      id: "2",
      name: "No",
    },
  ];

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible4, setCardVisible4] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [isCardVisible6, setCardVisible6] = useState(true);
  const [isCardVisible8, setCardVisible8] = useState(true);
  const [isCardVisible9, setCardVisible9] = useState(true);
  // const [isCardVisible10, setCardVisible10] = useState(true);
  const [isCardVisible11, setCardVisible11] = useState(true);
  const [isCardVisible12, setCardVisible12] = useState(true);
  const [isCardVisible14, setCardVisible14] = useState(true);

  // eslint-disable-next-line no-unused-vars
  const [getDropdownData, setDropdownData] = useState("");
  const [modalShow, setModalShow] = useState(false);

  // const [getCertificateData, setCertificateData] = useState();

  // const [getSelectedData, setSelectedData] = useState([]);
  // const [getDisabledRemove, setDisabledRemove] = useState(true);

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };
  const toggleCardVisibility4 = () => {
    setCardVisible4(!isCardVisible4);
  };
  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible5);
  };
  const toggleCardVisibility6 = () => {
    setCardVisible6(!isCardVisible6);
  };

  const toggleCardVisibility8 = () => {
    setCardVisible8(!isCardVisible8);
  };
  const toggleCardVisibility9 = () => {
    setCardVisible9(!isCardVisible9);
  };
  // const toggleCardVisibility10 = () => {
  //   setCardVisible10(!isCardVisible10);
  // };
  const toggleCardVisibility11 = () => {
    setCardVisible11(!isCardVisible11);
  };
  const toggleCardVisibility12 = () => {
    setCardVisible12(!isCardVisible12);
  };
  // const toggleCardVisibility13 = () => {
  //   setCardVisible13(!isCardVisible13);
  // };
  const toggleCardVisibility14 = () => {
    setCardVisible14(!isCardVisible14);
  };
  // const toggleCardVisibility15 = () => {
  //   setCardVisible15(!isCardVisible15);
  // };
  // const toggleCardVisibility16 = () => {
  //   setCardVisible16(!isCardVisible16);
  // };
  // const toggleCardVisibility17 = () => {
  //   setCardVisible17(!isCardVisible17);
  // };
  // /* Modal Function */
  // const categorySelection = () => {
  //   setModalShow(true);
  // };
  const hideModal = () => {
    setModalShow(false);
  };

  const [formInputs, setFormInputs] = useState({
    organisationName: "",
    companyName: "",
    email: "",
    firstName: "",
    lastName: "",
    roles: ["VENDOR"],
    category: ["VENDOR"],
    address: "",
    paymentsTerm: "",
    address2: "",
    city: "",
    countryCode: "",
    country: "",
    stateRegion: "",
    regionCode: "",
    cityPostalCode: "",
    contactTitle: "",
    contactNumber: "",
    contactfirstName: "",
    contactlastName: "",
    contactEmail: "",
    contactPhoneNr: "",
    companyOwner: "",
    companyLogo: "",
    CompanyBrochure: "",
    commodityServices: "",
    haveICVCertificate: "",
    natureOfBusiness: "",
    nameOwer: "",
    icvScore: "",
    icvCertificate: "",
    icvExpiryDate: "",
    vatRegistrationNumber: "",
    vatRegistrationExpiryDate: "",
    tradeLicenseNumber: "",
    tradeLicenseExpiryDate: "",
    BCMPlanPolicy: "",
    dealershipSetupType: "",
    MROcommoditybrand: "",
    brandName: "",
    OverseasTaxRegistrationNumber: "",
    issuingAuthorityAccreditation: "",
    chamberIncorporationCertificate: "",
    chamberIncorporationExpiryDate: "",
    humanRightsIssue: {
      HarassmentPolicy: "",
      ChildLabourPolicy: "",
      ForcedLabourPolicy: "",
      WorkingHoursPolicy: "",
      DiscriminationAtWorkPolicy: "",
      FreedomOfAssociationPolicy: "",
      CommuncationFullyUnderstood: "",
      ConflictMineralsIndigenousPeople: "",
    },
    financialDetails: {
      turnover1: "",
      turnover2: "",
    },
    categorySpecificInformation: {
      havingIso17025: "",
      safetyReqs: "",
      iso45001certificate: "",
      iso9001certificate: "",
      iso14001certificate: "",
      PoAinstituteIssued: "",
      isHseManagementManual: "",
      haveHseAuditProcedure: "",
      haveSkillTrainingSystem: "",
    },
    responsibleSourcing: {
      haveWrittenCodeOfConduct: "",
      alignedWithScComplianceEthics: "",
      haveWrittenRiskAssesProcessInSc: "",
      involvedInLocalCommunityProjects: "",
      haveWrittenPolicyOnAntiCorruption: "",
    },
    environmentalStewardship: {
      biodiversity: "",
      energyConsumption: "",
      wasteGeneration: "",
      climateChange: "",
      waterConsumption: "",
    },
    bankDetails: [],
    contactDetails: [
      {
        lastName: "",
        firstName: "",
        contactEmail: "",
        contactTitle: "",
        contactNumber: "",
        contactPosition: "",
      },
    ],
    certifications: [],
  });

  // Don't remove this
  // const contactAddressData = {
  //   lastName: "",
  //   firstName: "",
  //   contactEmail: "",
  //   contactTitle: "",
  //   contactNumber: "",
  //   contactPosition: "",
  // };

  const bankInfoInitialData = {
    bankNotListed: "",
    bankAccountNumber: "",
    bankKey: "",
    bankName: "",
    bankCountry: "",
    bankAddress: "",
    iban: "",
    AccountHolderName: "",
    bankCompanyletterhead: "",
    bankConfirmationLetter: "",
    chipsCode: "",
    swiftIfscCode: "",
    bankInfoTemplate: "",
    preferredCurrency: "",
  };

  const [getBankDetails, setBankDetails] = useState([]);

  // const [disabled, setDisabled] = useState(false);
  const [getDisabledStatus, setDisabledStatus] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [getBankDetailsData, setBankDetailsData] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [getJobTitleData, setJobTitleData] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [getContactTitleData, setContactTitleData] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [getCountry, setCountry] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [getState, setState] = useState([]);
  const [getcontactPosition] = useState([]);
  const [getTitle] = useState([]);
  // Documents Type Blocks
  const [getdocumentType, setdocumentType] = useState([]);

  // Commmon OnChange of the input scetion
  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    // console.log("onInputChange => formInputs", formInputs);
  };

  const loadFirstLevelData = async () => {
    if (supplierID || userInfo?.userId) {
      let obj = {
        userId: supplierID || userInfo?.userId,
      };

      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });

      await ItemService.getUserDetail(obj).then((item) => {
        // console.log(">> res!", item);
        if (item?.status === 200) {
          setDisabledStatus(true);
          setFormInputs(item?.data);
          // setCertificateData(item?.data?.certifications);
          setData(item?.data?.vendorCategory);
          item.data?.bankDetails
            ? setBankDetails(item.data?.bankDetails)
            : setBankDetails([...getBankDetails, bankInfoInitialData]);
          item.data?.projectDetails
            ? setProjectDetails(item?.data?.projectDetails)
            : setProjectDetails(...getProjectDetails);
          item.data?.documentTypeData
            ? setDocumentTypeData(item?.data?.documentTypeData)
            : setDocumentTypeData(...getDocumentTypeData);

          setLoading(false);
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
        toast.dismiss(toastId);
      });
    } else {
      // navigate(Constants.INBOX);
      window.history.back();
    }
    let obj5 = {
      codeType: "documentType",
    };
    await ItemService.getMasterDataSelf(obj5).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setdocumentType(item?.data);
      } else {
        setdocumentType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };

  useEffect(() => {
    loadFirstLevelData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    {
      name: "Category Code",
      selector: (row) => row.vendorCategoryCode || "--",
      sortable: true,
      width: "250px",
    },
    {
      name: "Category",
      selector: (row) => row.vendorCategoryText || "--",
      sortable: true,
      width: "280px",
    },

    {
      name: "SubCategory",
      selector: (row) => row.vendorSubCategoryText || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "SubCategory Code",
      selector: (row) => row.vendorSubCategoryCode || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "SubCategory Description",
      selector: (row) => row.vendorSubCategoryLongText || "--",
      sortable: true,
      width: "400px",
    },
  ];

  // const companyDocumentsCol = [
  //   {
  //     name: "Name",
  //     selector: (row) => row.name || "--",
  //     sortable: true,
  //     width: "250px",
  //   },
  //   {
  //     name: "Document Type",
  //     selector: (row) => row.documentType || "--",
  //     sortable: true,
  //     width: "280px",
  //   },

  //   {
  //     name: "Document Number",
  //     selector: (row) => row.documentNumber || "--",
  //     sortable: true,
  //     width: "200px",
  //   },
  //   {
  //     name: "Expiration Date",
  //     selector: (row) => row.expirationDate || "--",
  //     sortable: true,
  //     width: "200px",
  //   },
  //   {
  //     name: "Issuing Authority",
  //     selector: (row) => row.issuingAuthority || "--",
  //     sortable: true,
  //     width: "400px",
  //   },
  //   {
  //     name: "Certificate Code",
  //     selector: (row) => row.certificateCode || "--",
  //     sortable: true,
  //     width: "400px",
  //   },
  // ];

  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };
  // const onSuccessUploadfiles = (data) => {
  //   setFormInputs((prevData) => ({
  //     ...prevData,
  //     [data.fieldName]: data.attachmentId,
  //   }));
  // };

  /* ---------------------project details block-------- */
  // const addProjectDetails = () => {
  //   newProject.projectCode = nextId + 1;
  //   newProject.projectCodeDesc = "PROJECT_" + (nextId + 1);
  //   setProjectDetails((prevData) => [...prevData, newProject]);
  //   setNextId((prevId) => prevId + 1);
  // };

  const removeProjectDetails = (indexToRemove) => {
    setProjectDetails(
      getProjectDetails.filter((_, idx) => idx !== indexToRemove)
    );
  };

  const handleProjectInputChange = (value, index, fieldName) => {
    // console.log(">>handleProjectInputChange", { index, fieldName, value });

    if (index === undefined || value === undefined) return;

    // Update the specific project detail
    setProjectDetails((prevDetails) =>
      prevDetails.map((item, idx) =>
        idx === index ? { ...item, [fieldName]: value } : item
      )
    );
  };

  /* --------------------- Contact Person Inside Project Details -------- */

  //Add Projects
  // const addProjectCantactPersonNew = (projectIndex) => {
  //   const newContactPerson = {
  //     id: Date.now(), // Unique ID for each contact person
  //     projectContactPosition: "",
  //     projectContactTitle: "",
  //     projectContactName: "",
  //     projectContactNumber: "",
  //     projectContactEmail: "",
  //   };

  //   setProjectDetails((prevData) => {
  //     const updatedProjectDetails = [...prevData];
  //     updatedProjectDetails[projectIndex] = {
  //       ...updatedProjectDetails[projectIndex],
  //       getProjectContactPerson: [
  //         ...updatedProjectDetails[projectIndex].getProjectContactPerson,
  //         newContactPerson,
  //       ],
  //     };
  //     return updatedProjectDetails;
  //   });
  // };

  //Delete Project
  const deleteProjectContactPerosnNew = (projectIndex, id) => {
    setProjectDetails((prevData) => {
      const updatedProjectDetails = [...prevData];
      updatedProjectDetails[projectIndex] = {
        ...updatedProjectDetails[projectIndex],
        getProjectContactPerson: updatedProjectDetails[
          projectIndex
        ].getProjectContactPerson.filter((contact) => contact.id !== id),
      };
      return updatedProjectDetails;
    });
  };

  //Project Contact Inputs
  const handleChangeProjectContactsNew = (
    projectIndex,
    contactId,
    fieldName,
    value
  ) => {
    setProjectDetails((prevData) => {
      const updatedProjectDetails = [...prevData];
      updatedProjectDetails[projectIndex] = {
        ...updatedProjectDetails[projectIndex],
        getProjectContactPerson: updatedProjectDetails[
          projectIndex
        ].getProjectContactPerson.map(
          (contact) =>
            contact.id === contactId
              ? { ...contact, [fieldName]: value } // Update the specific field
              : contact // Keep other contacts unchanged
        ),
      };
      return updatedProjectDetails;
    });
  };

  //Dropdown
  const handleChangeProjectContactsNewDropdown = (
    projectIndex,
    contactId,
    fieldName,
    value
  ) => {
    setProjectDetails((prevData) => {
      const updatedProjectDetails = [...prevData];

      // Update the specific contact person's field
      updatedProjectDetails[projectIndex] = {
        ...updatedProjectDetails[projectIndex],
        getProjectContactPerson: updatedProjectDetails[
          projectIndex
        ].getProjectContactPerson.map(
          (contact) =>
            contact.id === contactId
              ? { ...contact, [fieldName]: value.name } // Update the field with the full object
              : contact // Keep other contacts unchanged
        ),
      };

      return updatedProjectDetails;
    });
  };

  /* ---------------------project Certifications  -------- */

  const deleteProjectCertifications = (projectIndex, certificationId) => {
    setProjectDetails((prevData) => {
      const updatedProjectDetails = [...prevData];

      // Filter out the certification with the specified id
      updatedProjectDetails[projectIndex] = {
        ...updatedProjectDetails[projectIndex],
        getProjectCertifications: updatedProjectDetails[
          projectIndex
        ].getProjectCertifications.filter(
          (certification) => certification.id !== certificationId
        ),
      };

      return updatedProjectDetails;
    });
  };

  // const addProjectCertifications = (projectIndex) => {
  //   const newCertification = {
  //     id: Date.now(), // Unique ID for the new certification
  //     name: "Document 1",
  //     documentType: "",
  //     certificateCode: "29AADCN1012B1Z6",
  //     stageDocument: "",
  //   };
  //   setProjectDetails((prevData) => {
  //     const updatedProjectDetails = [...prevData];

  //     // Add the new certification to the getProjectCertifications array
  //     updatedProjectDetails[projectIndex] = {
  //       ...updatedProjectDetails[projectIndex],
  //       getProjectCertifications: [
  //         ...updatedProjectDetails[projectIndex].getProjectCertifications,
  //         newCertification,
  //       ],
  //     };
  //     return updatedProjectDetails;
  //   });
  // };

  //document upload for projects
  // const onSuccessUploadProjectDocumentType = (
  //   projectIndex,
  //   docId,
  //   fieldName,
  //   attachmentId
  // ) => {
  //   setProjectDetails((prevData) => {
  //     const updatedProjectDetails = [...prevData];
  //     updatedProjectDetails[projectIndex] = {
  //       ...updatedProjectDetails[projectIndex],
  //       getProjectCertifications: updatedProjectDetails[
  //         projectIndex
  //       ].getProjectCertifications.map((cert) =>
  //         cert.id === docId ? { ...cert, [fieldName]: attachmentId } : cert
  //       ),
  //     };

  //     return updatedProjectDetails;
  //   });
  // };
  const newProject = {
    projectCode: 1,
    projectCodeDesc: "PROJECT_1",
    projectName: "",
    projectAddress: "",
    projectAddress2: "",
    projectCity: "",
    projectCountry: "IN - India",
    projectState: "IN - Karanataka",
    projectCityPostalCode: "",
    getProjectContactPerson: [
      {
        id: Date.now(), // Unique ID for the first contact person
        projectContactPosition: "",
        projectContactTitle: "",
        projectContactName: "",
        projectContactNumber: "",
        projectContactEmail: "",
      },
    ],
    getProjectCertifications: [
      {
        id: Date.now(),
        name: "Document 1",
        documentType: "",
        certificateCode: "29AADCN1012B1Z6",
        stageDocument: "",
      },
    ],
    getLocations: [],
  };
  // let routNumberDropdownOption = [
  //   {
  //     id: "1",
  //     name: "1",
  //   },
  //   {
  //     id: "2",
  //     name: "2",
  //   },
  //   {
  //     id: "3",
  //     name: "3",
  //   },
  // ];
  const [getProjectDetails, setProjectDetails] = useState([newProject]);

  // const [nextId, setNextId] = useState(1); // Start IDs from 1
  let productDocumentAttachment = [
    {
      id: "1",
      name: "Stage1",
    },
    {
      id: "2",
      name: "Stage2",
    },
    {
      id: "3",
      name: "Stage3",
    },
    {
      id: "4",
      name: "Stage4",
    },
    {
      id: "5",
      name: "Stage5",
    },

    {
      id: "6",
      name: "Google Pin location",
    },
    {
      id: "7",
      name: "Project Photos",
    },
    {
      id: "8",
      name: "Blueprints or Layout Plans",
    },
    {
      id: "9",
      name: "Project Document",
    },
    {
      id: "10",
      name: "Others",
    },
  ];

  const [selectedDropdownOption, setSelectedDropdownOption] = useState("");

  useEffect(() => {
    setSelectedDropdownOption(formInputs.alignedWithScComplianceEthics);
  }, [formInputs]);

  /*documetn type  */

  const [getDocumentTypeData, setDocumentTypeData] = useState([
    {
      id: Date.now(),
      name: "Document 1",
      documentType: "",
      documentNumber: "",
      issueDate: "",
      issuingAuthority: "",
    },
  ]);

  const onSuccessUploadDocumentType = (data) => {
    setDocumentTypeData((prevData) =>
      prevData.map((doc) =>
        doc.id === data.fieldId
          ? { ...doc, [data.fieldName]: data.attachmentId }
          : doc
      )
    );
  };
  const handleInputChange = (id, fieldName, value) => {
    setDocumentTypeData((prevData) =>
      prevData.map((doc) =>
        doc.id === id ? { ...doc, [fieldName]: value } : doc
      )
    );
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">
              {formInputs?.supplierTypeCode === "S01" ? (
                <>Normal Vendor Details</>
              ) : (
                <>Factory Vendor Details</>
              )}{" "}
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {supplierID || userInfo?.userId}
              </span>
              <span>
                {formInputs.status === "Non Invited" ? (
                  <span className="bg-table-status bg-table-info-status headerStatusDetailedPage">
                    {formInputs.status}
                  </span>
                ) : formInputs.status === "Invited" ? (
                  <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                    {formInputs.status}
                  </span>
                ) : formInputs.status === "In Registration" ? (
                  <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                    {formInputs.status}
                  </span>
                ) : formInputs.status === "Registered" ? (
                  <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                    {formInputs.status}
                  </span>
                ) : formInputs.status === "Reject" ? (
                  <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                    {formInputs.status}
                  </span>
                ) : formInputs.status === "Deactivated" ? (
                  <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                    {formInputs.status}
                  </span>
                ) : (
                  formInputs.status
                )}
              </span>
            </h2>
            <p className="subText">Vendor Registration Information </p>
            <hr />

            {config?.showInSupplierDetailPage && workflow?.length > 0 && (
              <ShowHorizontalStatus rowdatamodal={workflow} />
            )}

            {(formInputs.status === "Non Invited" ||
              formInputs.status === "Registered" ||
              formInputs.status === "Invited" ||
              formInputs.status === "In Registration") && (
              <>
                {/* 01 Basic Information */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">BI</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">Basic Information</span>
                          <span className="subHeaderTitle">
                            Supplier Basic Information
                          </span>
                        </Col>

                        <Col xs={2} md={1} lg={1} className="">
                          <CommonFillter />
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Supplier Name"
                              name="organisationName"
                              extraLabel="As per the Trade license"
                              placeholder=""
                              value={formInputs.organisationName || ""}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Status"
                              name="status"
                              placeholder=""
                              value={formInputs.status || ""}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Purpose/Justification"
                              type="text"
                              name="purposeJustification"
                              placeholder=""
                              value={formInputs.purposeJustification || ""}
                              disabled={true}
                              onChange={onInputChange}
                              // disabled={getDisabledStatus}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="initiator"
                              name="initiator"
                              placeholder=""
                              value={formInputs.initiator || ""}
                              disabled={true}
                              onChange={onInputChange}
                              // disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="initiator Name"
                              name="initiatorName"
                              placeholder=""
                              value={formInputs.initiatorName || ""}
                              disabled={true}
                              onChange={onInputChange}
                              // disabled={getDisabledStatus}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
                {/* 02 General Information */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible2
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility2}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">GI</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">
                            General Information
                          </span>
                          <span className="subHeaderTitle">
                            Supplier General Information
                          </span>
                        </Col>

                        <Col xs={2} md={1} lg={1} className="">
                          <CommonFillter />
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible2 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label=" Name of Company Owner as on license "
                              extraLabel="Name of Company Owner as on license"
                              name="companyOwner"
                              placeholder=""
                              value={formInputs?.companyOwner || ""}
                              onChange={onInputChange}
                              disabled={true}
                              // disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              className="inputBox"
                              label="Nature of business"
                              // extraLabel="Web site URL /Logo  and Company Brochure Attachment"
                              name="natureOfBusiness"
                              placeholder=""
                              value={formInputs.natureOfBusiness || ""}
                              onChange={onInputChange}
                              disabled={true}
                              //  error={validation.natureOfBusiness}
                              // required={true}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding  justify-content-center align-items-center"
                          >
                            <div className="d-flex flex-column ">
                              <p className="fw-medium m-0 text-nowrap">
                                Company Brochure
                              </p>

                              {/* {(formInputs?.companyBrochure1 && ( */}
                              {(formInputs?.companyBrochure1 && (
                                <img
                                  src="assets/img/newIcons/attached-file.png"
                                  className="mt-1 attachmentIcon"
                                  alt="attachments"
                                  onClick={() =>
                                    handleViewFile(formInputs?.companyBrochure1)
                                  }
                                />
                              )) ||
                                "--"}
                            </div>
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Payments Term"
                              placeholder=""
                              // data={PaymentTermsOptions}
                              id="paymentsTerm"
                              iconClassName="dropdownIcon"
                              name="paymentsTerm"
                              // code="supplierTypeCode"
                              // description="supplierTypeDesc"
                              value={formInputs.paymentsTerm}
                              disabled={true}
                              // getvalue={setDropdownData}
                              // error={validation.paymentsTerm}
                              // required={true}
                            />
                          </Col>

                          {/* <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                          
                             {(formInputs?.companyBrochure && (
                          <img
                            src="assets/img/newIcons/attached-file.png"
                            className="mt-1 attachmentIcon"
                            alt="attachments"
                            onClick={() =>
                              handleViewFile(formInputs?.companyBrochure)
                            }
                          />
                        )) ||
                          "--"}
                          </Col> */}
                          {/* <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Website and Company Brochure"
                              name="CompanyBrochure"
                              placeholder=""
                              value={formInputs?.CompanyBrochure || ""}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                            <div className="col-sm-10">
                              <input
                                className="form-control"
                                type="file"
                                id="formFile"
                              />
                            </div>
                          </Col> */}
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
                {/* 03 Company Address */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible3
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility3}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">CA</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">Company Address</span>
                          <span className="subHeaderTitle">
                            Address of the Company
                          </span>
                        </Col>

                        <Col xs={2} md={1} lg={1} className="">
                          <CommonFillter />
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible3 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label=" Address Lines 1 / Street"
                              name="address"
                              placeholder=""
                              value={formInputs.address || ""}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Address Line 2"
                              name="address2"
                              placeholder=""
                              value={formInputs.address2 || ""}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="City"
                              name="city"
                              placeholder=""
                              value={formInputs.city || ""}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Country"
                              placeholder=""
                              data={getCountry}
                              id="country"
                              iconClassName="dropdownIcon"
                              name="country"
                              setValue={formInputs.country}
                              getvalue={setDropdownData}
                              disabled={getDisabledStatus}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="State / Emirate / Province (Region)"
                              placeholder=""
                              data={getState}
                              id="state"
                              iconClassName="dropdownIcon"
                              name="state"
                              setValue={formInputs.state}
                              getvalue={setDropdownData}
                              disabled={getDisabledStatus}
                              // className="dropdownOption"
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Postal Code/PO Box"
                              name="cityPostalCode"
                              placeholder=""
                              value={formInputs.cityPostalCode || ""}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
                {/* 04 Contact Person */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible4
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility4}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">CP</span>
                        </Col>
                        <Col xs={12} md={8} lg={8}>
                          <span className="headerTitle">Contact Person</span>
                          <span className="subHeaderTitle">
                            Contact Person Details
                          </span>
                        </Col>
                        {/* <Col xs={4} md={2} lg={2} className="">
                          <button
                            className="btnTable"
                            onClick={() => addContactAddress()}
                            disabled={getDisabledStatus}
                          >
                            <i className="bi bi-plus-lg"></i> Add Contact
                          </button>
                        </Col> */}

                        <Col xs={2} md={1} lg={1} className="">
                          <CommonFillter />
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible4 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Job Title"
                              placeholder=""
                              data={getJobTitleData}
                              id="contactPosition"
                              iconClassName="dropdownIcon"
                              name="contactPosition"
                              code="contactPositionCode"
                              description="contactPositionDesc"
                              setValue={formInputs.contactPosition}
                              getvalue={setDropdownData}
                              disabled={getDisabledStatus}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Contact Title"
                              placeholder=""
                              data={getContactTitleData}
                              id="contactTitle"
                              iconClassName="dropdownIcon"
                              name="contactTitle"
                              code="contactTitleCode"
                              description="contactTitleDesc"
                              setValue={formInputs.contactTitle}
                              getvalue={setDropdownData}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Contact First Name"
                              name="contactfirstName"
                              placeholder=""
                              value={formInputs.contactfirstName || ""}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Contact Last Name"
                              name="contactlastName"
                              placeholder=""
                              value={formInputs.contactlastName || ""}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Contact Email"
                              name="email"
                              placeholder=""
                              value={formInputs.email || ""}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Contact Number"
                              name="contactNumber"
                              placeholder=""
                              value={formInputs.contactNumber || ""}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Alternate Contact Number"
                              name="alternateContactNumber"
                              placeholder=""
                              value={formInputs.alternateContactNumber || ""}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Alternate Email-ID"
                              name="alternateEmailId"
                              placeholder=""
                              value={formInputs.alternateEmailId || ""}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
                {/* 06 Category Selection */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible6
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility6}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">CS</span>
                        </Col>
                        <Col xs={12} md={6} lg={6}>
                          <span className="headerTitle">
                            Category Selection
                          </span>
                          <span className="subHeaderTitle">
                            Select Required Category
                          </span>
                        </Col>
                        <Col xs={2} md={1} lg={1} className="">
                          <CommonFillter />
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible6 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col xs={12} md={12} lg={12}>
                            <DataTable
                              title=""
                              columns={columns}
                              data={data}
                              progressPending={loading}
                              paginationRowsPerPageOptions={
                                Constants.ROW_PER_PAGE
                              }
                              pagination
                              // paginationServer
                              // paginationTotalRows={totalRows}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              selectableRows
                              // onSelectedRowsChange={handleChange}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
                {formInputs.supplierTypeCode === "S02" && (
                  <>
                    <div className="accordion mb-4" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <Row className="accordion-button">
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-left arrowBtn"
                            >
                              <i
                                className={`bi ${
                                  isCardVisible4
                                    ? "bi-chevron-right"
                                    : "bi-chevron-down"
                                }`}
                                onClick={toggleCardVisibility4}
                              ></i>
                            </Col>
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-center logoBtn"
                            >
                              <span className="iconLogo">FD</span>
                            </Col>
                            <Col xs={8} md={8} lg={8}>
                              <span className="headerTitle">
                                Factory Details{" "}
                              </span>
                              <span className="subHeaderTitle">
                                Factory Details
                              </span>
                            </Col>
                            {/* <Col xs={4} md={2} lg={2}>
                            <div className="d-flex justify-content-end  p-2 me-3">
                              <button
                                className="btnTable"
                                onClick={() => addProjectDetails()}
                              >
                                <i className="bi bi-plus-lg"></i> Add Factory
                              </button>
                            </div>
                          </Col> */}
                          </Row>
                        </h2>
                        <div
                          className={`accordion-collapse collapse show ${
                            isCardVisible4 ? "visible" : ""
                          }`}
                        >
                          <div className="accordion-body">
                            {getProjectDetails &&
                              getProjectDetails?.map((item, index) => (
                                <div key={index}>
                                  <Row className="pt-2 pb-4">
                                    <Col
                                      xs={12}
                                      md={12}
                                      lg={12}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <h5 className="bg-table-status bg-table-new-status mt-3 p-3">
                                        Factory Details {index + 1}
                                      </h5>
                                      <span
                                        className="deleteIconAccordion"
                                        onClick={() =>
                                          removeProjectDetails(index)
                                        }
                                      >
                                        {" "}
                                        <i className="bi bi-x-circle"></i>{" "}
                                      </span>
                                    </Col>
                                    <Col
                                      xs={12}
                                      md={4}
                                      lg={4}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Factory Name"
                                        extraLabel="As per the trade license"
                                        name="projectName"
                                        value={item.projectName || ""}
                                        disabled={true}
                                        onChange={(e) =>
                                          handleProjectInputChange(
                                            e.target.value,
                                            index,
                                            "projectName"
                                          )
                                        }
                                        required={true}
                                      />
                                    </Col>
                                    <Col
                                      xs={12}
                                      md={4}
                                      lg={4}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Address Lines 1 / Street"
                                        extraLabel="As per the trade license"
                                        name="projectAddress"
                                        value={item.projectAddress || ""}
                                        disabled={true}
                                        onChange={(e) =>
                                          handleProjectInputChange(
                                            e.target.value,
                                            index,
                                            "projectAddress"
                                          )
                                        }
                                        required={true}
                                      />
                                    </Col>
                                    <Col
                                      xs={12}
                                      md={4}
                                      lg={4}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Address Line 2"
                                        extraLabel="As per the trade license"
                                        name="projectAddress2"
                                        value={item.projectAddress2 || ""}
                                        disabled={true}
                                        onChange={(e) =>
                                          handleProjectInputChange(
                                            e.target.value,
                                            index,
                                            "projectAddress2"
                                          )
                                        }
                                        required={true}
                                      />
                                    </Col>
                                    <Col
                                      xs={12}
                                      md={4}
                                      lg={4}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="City"
                                        extraLabel="As per the trade license"
                                        name="projectCity"
                                        value={item.projectCity || ""}
                                        disabled={true}
                                        onChange={(e) =>
                                          handleProjectInputChange(
                                            e.target.value,
                                            index,
                                            "projectCity"
                                          )
                                        }
                                        required={true}
                                      />
                                    </Col>
                                    <Col
                                      xs={12}
                                      md={4}
                                      lg={4}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <ComboboxField
                                        label="Country"
                                        placeholder=""
                                        data={getCountry}
                                        id="projectCountry"
                                        iconClassName="dropdownIcon"
                                        name="projectCountry"
                                        code="projectCountryCode"
                                        description="projectCountryDesc"
                                        setValue={item?.projectCountry}
                                        getvalue={setDropdownData}
                                        disabled={true}
                                        index={item.id}
                                        onChangeValue={(value) =>
                                          handleProjectInputChange(
                                            value,
                                            index,
                                            "projectCountry"
                                          )
                                        }
                                      />
                                    </Col>
                                    <Col
                                      xs={12}
                                      md={4}
                                      lg={4}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <ComboboxField
                                        label="State"
                                        placeholder=""
                                        data={getState}
                                        id="projectState"
                                        iconClassName="dropdownIcon"
                                        name="projectState"
                                        code="projectStateCode"
                                        description="projectStateDesc"
                                        setValue={item?.projectState}
                                        getvalue={setDropdownData}
                                        disabled={true}
                                        index={item.id}
                                        onChangeValue={(value) =>
                                          handleProjectInputChange(
                                            value,
                                            index,
                                            "projectState"
                                          )
                                        }
                                      />
                                    </Col>
                                    <Col
                                      xs={12}
                                      md={4}
                                      lg={4}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Postal Code/PO Box"
                                        extraLabel="As per the trade license"
                                        name="projectCityPostalCode"
                                        value={item.projectCityPostalCode || ""}
                                        disabled={true}
                                        onChange={(e) =>
                                          handleProjectInputChange(
                                            e.target.value,
                                            index,
                                            "projectCityPostalCode"
                                          )
                                        }
                                        required={true}
                                      />
                                    </Col>
                                  </Row>

                                  <Row>
                                    <Col
                                      xs={12}
                                      md={12}
                                      lg={12}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <div>
                                        <div className="d-flex-column justify-content-center">
                                          <Row>
                                            <Col xs={12} md={5} lg={5}>
                                              <h5 className="bg-table-status bg-table-warning-status mt-1">
                                                Factory Contacts
                                              </h5>
                                            </Col>

                                            <Col xs={12}>
                                              <div className="accordion-body">
                                                <div className="d-flex-column justify-content-center">
                                                  <Row className="pt-4 d-none d-lg-flex ">
                                                    <Col xs={12} md={2} lg={2}>
                                                      <p className="fs-6 fw-medium d-flex ms-4">
                                                        Job Title
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={2}>
                                                      <p className="fs-6 fw-medium d-flex ms-4">
                                                        Contact Title
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={2}>
                                                      <p className="fs-6 fw-medium d-flex ms-4">
                                                        Contact Person
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={2}>
                                                      <p className="fs-6 fw-medium d-flex ms-4">
                                                        Contact Number
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={2}>
                                                      <p className="fs-6 fw-medium d-flex ms-4">
                                                        Email-ID
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={2}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Action
                                                      </p>
                                                    </Col>
                                                  </Row>
                                                  {item?.getProjectContactPerson.map(
                                                    (doc, itemIndex) => (
                                                      <Row key={doc.id}>
                                                        <Col xs={12}>
                                                          <hr className="mx-4 my-0 text-color-black" />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={4}
                                                          lg={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxFieldSubArray
                                                            label=""
                                                            placeholder="Job Title"
                                                            data={
                                                              getcontactPosition
                                                            }
                                                            id="projectContactPosition"
                                                            name="projectContactPosition"
                                                            code="projectContactPositionCode"
                                                            description="projectContactPositionDesc"
                                                            disabled={true}
                                                            setValue={
                                                              doc.projectContactPosition
                                                            }
                                                            index={index} // Pass projectIndex instead of doc.id
                                                            onChangeValue={(
                                                              projectIndex,
                                                              contactId,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleChangeProjectContactsNewDropdown(
                                                                projectIndex,
                                                                doc.id,
                                                                fieldName,
                                                                value
                                                              )
                                                            }
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={4}
                                                          lg={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxFieldSubArray
                                                            label=""
                                                            placeholder="Contact Title"
                                                            data={getTitle}
                                                            id="projectContactTitle"
                                                            iconClassName="dropdownIcon"
                                                            name="projectContactTitle"
                                                            code="projectContactTitleCode"
                                                            description="projectContactTitleDesc"
                                                            disabled={true}
                                                            setValue={
                                                              doc.projectContactTitle
                                                            }
                                                            index={index} // Pass projectIndex instead of doc.id
                                                            onChangeValue={(
                                                              projectIndex,
                                                              contactId,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleChangeProjectContactsNewDropdown(
                                                                projectIndex,
                                                                doc.id,
                                                                fieldName,
                                                                value
                                                              )
                                                            }
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={4}
                                                          lg={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <InputField
                                                            className="inputBox mt-1"
                                                            name="projectContactName"
                                                            placeholder="Contact Person"
                                                            disabled={true}
                                                            value={
                                                              doc.projectContactName ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleChangeProjectContactsNew(
                                                                index,
                                                                doc.id,
                                                                "projectContactName",
                                                                e.target.value
                                                              )
                                                            }
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={4}
                                                          lg={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <InputField
                                                            className="inputBox mt-1"
                                                            name="projectContactNumber"
                                                            placeholder="Contact Number"
                                                            disabled={true}
                                                            value={
                                                              doc.projectContactNumber ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleChangeProjectContactsNew(
                                                                index,
                                                                doc.id,
                                                                "projectContactNumber",
                                                                e.target.value
                                                              )
                                                            }
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={4}
                                                          lg={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <InputField
                                                            className="inputBox mt-1"
                                                            name="projectContactEmail"
                                                            placeholder="Email"
                                                            disabled={true}
                                                            value={
                                                              doc.projectContactEmail ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleChangeProjectContactsNew(
                                                                index,
                                                                doc.id,
                                                                "projectContactEmail",
                                                                e.target.value
                                                              )
                                                            }
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={4}
                                                          lg={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <div className="d-flex">
                                                            {item
                                                              ?.getProjectContactPerson
                                                              .length !== 1 && (
                                                              <i
                                                                onClick={() =>
                                                                  deleteProjectContactPerosnNew(
                                                                    index,
                                                                    doc.id
                                                                  )
                                                                }
                                                                className="bi bi-trash text-danger fs-4"
                                                              />
                                                            )}

                                                            {/* {itemIndex ===
                                                            item
                                                              ?.getProjectContactPerson
                                                              .length -
                                                            1 && (
                                                              <button
                                                                className="btnTable width-40 ml-6 mt-1"
                                                                onClick={() =>
                                                                  addProjectCantactPersonNew(
                                                                    index
                                                                  )
                                                                } // Fixed: Pass as a callback
                                                              >
                                                                <i className="bi bi-plus-lg"></i>{" "}
                                                                Add
                                                              </button>
                                                            )} */}
                                                          </div>
                                                        </Col>
                                                      </Row>
                                                    )
                                                  )}
                                                </div>
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>

                                  <Row>
                                    <Col
                                      xs={12}
                                      md={12}
                                      lg={12}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <div>
                                        <div className="d-flex-column justify-content-center">
                                          <Row>
                                            <Col xs={12} md={5} lg={5}>
                                              <h5 className="bg-table-status bg-table-warning-status mt-4">
                                                Factory Stages
                                              </h5>
                                            </Col>
                                            <Col xs={12}>
                                              <div className="accordion-body">
                                                <div className="d-flex-column justify-content-center">
                                                  <Row className="pt-4 d-none d-lg-flex ">
                                                    <Col xs={12} md={2} lg={2}>
                                                      <p className="fs-6 fw-medium d-flex ms-4">
                                                        Stages
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={1}>
                                                      <p className="fs-6 fw-medium d-flex ms-4">
                                                        View Files
                                                      </p>
                                                    </Col>
                                                    {/* <Col xs={12} md={4} lg={3}>
                                                    <p className="fs-6 fw-medium d-flex ms-4">
                                                      Attachments
                                                    </p>
                                                  </Col> */}

                                                    {/* <Col xs={12} md={4} lg={3}>
                                                    <p className="fs-6 fw-medium d-flex">
                                                      Action
                                                    </p>
                                                  </Col> */}
                                                  </Row>
                                                  {item.getProjectCertifications.map(
                                                    (doc, itemIndex) => (
                                                      <Row key={doc.id}>
                                                        <Col xs={12}>
                                                          <hr className="mx-4 my-0 text-color-black" />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={4}
                                                          lg={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxFieldSubArray
                                                            label=""
                                                            placeholder="Stages"
                                                            disabled={true}
                                                            data={
                                                              productDocumentAttachment
                                                            }
                                                            id="documentType"
                                                            iconClassName="dropdownIcon"
                                                            name="documentType"
                                                            code="documentTypeCode"
                                                            description="documentTypeDesc"
                                                            setValue={
                                                              doc.documentType
                                                            }
                                                            index={index} // Pass projectIndex instead of doc.id
                                                            onChangeValue={(
                                                              projectIndex,
                                                              fileId,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleChangeProjectContactsNewDropdown(
                                                                projectIndex,
                                                                doc.id,
                                                                fieldName,
                                                                value
                                                              )
                                                            }
                                                          />
                                                        </Col>
                                                        {/* <Col
                                                                                          xs={12}
                                                                                          md={4}
                                                                                          lg={1}
                                                                                          className="commTopButtonRightLeftPadding"
                                                                                        >
                                                                                          <div className="d-flex justify-content-center">
                                                                                            {(doc.iSOCertification && (
                                                                                              <img
                                                                                                src="assets/img/newIcons/attached-file.png"
                                                                                                className="mt-1 attachmentIcon"
                                                                                                alt="attachments"
                                                                                                onClick={() =>
                                                                                                  handleViewFile(
                                                                                                    doc.iSOCertification
                                                                                                  )
                                                                                                }
                                                                                              />
                                                                                            )) ||
                                                                                              "--"}
                                                                                          </div>
                                                                                        </Col> */}
                                                        <Col
                                                          xs={12}
                                                          md={4}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <div className="d-flex justify-content-center">
                                                            {(doc.stageDocument && (
                                                              <img
                                                                src="assets/img/newIcons/attached-file.png"
                                                                className="mt-1 attachmentIcon"
                                                                alt="attachments"
                                                                onClick={() =>
                                                                  handleViewFile(
                                                                    doc.stageDocument
                                                                  )
                                                                }
                                                              />
                                                            )) ||
                                                              "--"}
                                                          </div>
                                                        </Col>
                                                        {/* <Col
                                                        xs={12}
                                                        md={4}
                                                        lg={3}
                                                        className="commTopButtonRightLeftPadding"
                                                      >
                                                        <FileUploadComponent
                                                          id={doc.id}
                                                          name="stageDocument"
                                                          label=""
                                                          allowedTypes={[
                                                            "image/png",
                                                            "image/jpeg",
                                                            "application/pdf",
                                                          ]}
                                                          multiple={true} // Change to `false` for single file selection
                                                          required={true}
                                                          onSuccessUpload={(data) =>
                                                            onSuccessUploadProjectDocumentType(
                                                              index,
                                                              doc.id,
                                                              data.fieldName,
                                                              data.attachmentId
                                                            )
                                                          }
                                                          value={
                                                            doc.stageDocument || ""
                                                          }
                                                        />
                                                      </Col> */}

                                                        <Col
                                                          xs={12}
                                                          md={4}
                                                          lg={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <div className="d-flex">
                                                            {item
                                                              ?.getProjectCertifications
                                                              .length !== 1 && (
                                                              <i
                                                                onClick={() =>
                                                                  deleteProjectCertifications(
                                                                    index,
                                                                    doc.id
                                                                  )
                                                                }
                                                                className="bi bi-trash text-danger fs-4"
                                                              />
                                                            )}

                                                            {/* {itemIndex ===
                                                            item
                                                              ?.getProjectCertifications
                                                              .length -
                                                            1 && (
                                                              <button
                                                                className="btnTable width-40 ml-6 mt-1"
                                                                onClick={() =>
                                                                  addProjectCertifications(
                                                                    index
                                                                  )
                                                                } // Fixed: Pass as a callback
                                                              >
                                                                <i className="bi bi-plus-lg"></i>{" "}
                                                                Add
                                                              </button>
                                                            )} */}
                                                          </div>
                                                        </Col>
                                                      </Row>
                                                    )
                                                  )}
                                                </div>
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>
                                        <div className="d-flex-column justify-content-center">
                                          <Row>
                                            <Col xs={12} md={5} lg={5}>
                                              <h5 className="bg-table-status bg-table-warning-status mt-4">
                                                QMS
                                              </h5>
                                            </Col>
                                            <Col xs={12}>
                                              <div className="accordion-body">
                                                <div className="d-flex-column justify-content-center">
                                                  <Row className="pt-4 d-none d-lg-flex ">
                                                    {/* <Col xs={12} md={2} lg={2}>
                                                    <p className="fs-6 fw-medium d-flex ms-4">
                                                      Are All The Panels Cut In The Factory
                                                    </p>
                                                  </Col> */}
                                                    <Col xs={12} md={4} lg={1}>
                                                      <p className="fs-6 fw-medium d-flex ms-4">
                                                        Questions
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex ms-4"></p>
                                                    </Col>

                                                    <Col xs={12} md={4} lg={4}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Remarks
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Upload Documents
                                                      </p>
                                                    </Col>
                                                  </Row>
                                                  {/* {item.getProjectCertifications.map(
                                                  (doc, itemIndex) => ( */}

                                                  <Row>
                                                    <div className="border p-3 rounded shadow-sm my-3">
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            1. Fabrics On
                                                            Palette And Covered
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="fabricsMou"
                                                            iconClassName="dropdownIcon"
                                                            name="fabricsMou"
                                                            code="fabricsMouCode"
                                                            description="fabricsMouDesc"
                                                            setValue={
                                                              item?.fabricsMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="fabricRemarks"
                                                            value={
                                                              item.fabricRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "fabricRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>
                                                        {/* <Col
                                                        xs={12}
                                                        md={4}
                                                        lg={4}
                                                        className="commTopButtonRightLeftPadding"
                                                      >

                                                        <FileUploadComponent
                                                          key={index}
                                                          name="fabricUploads"
                                                          label="DOC Upload"
                                                          allowedTypes={["image/png", "image/jpeg", "application/pdf"]}
                                                          multiple={true}
                                                          onSuccessUpload={(data) => onSuccessUploadfilesProduct(data, index)} // Pass index
                                                          value={item.fabricUploads || ""}
                                                        />
                                                      </Col> */}
                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.fabricUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.fabricUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            2. Location System
                                                            For Fabric Storage
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="locationMou"
                                                            iconClassName="dropdownIcon"
                                                            name="locationMou"
                                                            code="locationMouCode"
                                                            description="locationMouDesc"
                                                            setValue={
                                                              item?.locationMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="locationRemarks"
                                                            name="locationRemarks"
                                                            value={
                                                              item.locationRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "locationRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        {/* <Col
                                                        xs={12}
                                                        md={4}
                                                        lg={4}
                                                        className="commTopButtonRightLeftPadding"
                                                      >

                                                        <FileUploadComponent
                                                          key={index}
                                                          name="locationUploads"
                                                          label="DOC Upload"
                                                          allowedTypes={["image/png", "image/jpeg", "application/pdf"]}
                                                          multiple={true}
                                                          onSuccessUpload={(data) => onSuccessUploadfilesProduct(data, index)} // Pass index
                                                          value={item.locationUploads || ""}
                                                        />
                                                      </Col> */}
                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.locationUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.locationUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            3. Stock Keeping
                                                            Records
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="traceabilityMou"
                                                            iconClassName="dropdownIcon"
                                                            name="stockMou"
                                                            code="stockMouCode"
                                                            description="stockMouDesc"
                                                            setValue={
                                                              item?.stockMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="stockRemarks"
                                                            value={
                                                              item.stockRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "stockRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>
                                                        {/* <Col
                                                        xs={12}
                                                        md={4}
                                                        lg={4}
                                                        className="commTopButtonRightLeftPadding"
                                                      >

                                                        <FileUploadComponent
                                                          key={index}
                                                          name="stockUploads"
                                                          // label="DOC Upload"
                                                          allowedTypes={["image/png", "image/jpeg", "application/pdf"]}
                                                          multiple={true}
                                                          onSuccessUpload={(data) => onSuccessUploadfilesProduct(data, index)} // Pass index
                                                          value={item.stockUploads || ""}
                                                        />
                                                      </Col> */}
                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.stockUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.stockUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                    </div>
                                                  </Row>

                                                  {/* )
                                                )}  */}
                                                </div>
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>
                                        <div className="d-flex-column justify-content-center">
                                          <Row>
                                            <Col xs={12} md={5} lg={5}>
                                              <h5 className="bg-table-status bg-table-warning-status mt-4">
                                                Fabric Inspection System
                                              </h5>
                                            </Col>
                                            <Col xs={12}>
                                              <div className="accordion-body">
                                                <div className="d-flex-column justify-content-center">
                                                  <Row className="pt-4 d-none d-lg-flex ">
                                                    {/* <Col xs={12} md={2} lg={2}>
                                                                                          <p className="fs-6 fw-medium d-flex ms-4">
                                                                                            Are All The Panels Cut In The Factory
                                                                                          </p>
                                                                                        </Col> */}
                                                    <Col xs={12} md={4} lg={1}>
                                                      <p className="fs-6 fw-medium d-flex ms-4">
                                                        Questions
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex ms-4"></p>
                                                    </Col>

                                                    <Col xs={12} md={4} lg={4}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Remarks
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Upload Documents
                                                      </p>
                                                    </Col>
                                                  </Row>
                                                  {/* {item.getProjectCertifications.map(
                                                                                        (doc, itemIndex) => ( */}

                                                  <Row>
                                                    <div className="border p-3 rounded shadow-sm my-3">
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            1. No. Of Inspection
                                                            Machines
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="inspectionMou"
                                                            iconClassName="dropdownIcon"
                                                            name="inspectionMou"
                                                            code="inspectionMouCode"
                                                            description="inspectionMouDesc"
                                                            setValue={
                                                              item?.inspectionMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="inspectionRemarks"
                                                            value={
                                                              item.inspectionRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "inspectionRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.inspectionUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.inspectionUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            2. Type Of
                                                            Inspection System
                                                            Used
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="inspectionTypeMou"
                                                            iconClassName="dropdownIcon"
                                                            name="inspectionTypeMou"
                                                            code="inspectionTypeMouCode"
                                                            description="inspectionTypeMouDesc"
                                                            setValue={
                                                              item?.inspectionTypeMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="inspectionTypeRemarks"
                                                            name="inspectionTypeRemarks"
                                                            value={
                                                              item.inspectionTypeRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "inspectionTypeRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.inspectionTypeUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.inspectionTypeUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            3. Traceability Of
                                                            Shades Of Use Of
                                                            Fabric Dye Lot No?
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="traceabilityMou"
                                                            iconClassName="dropdownIcon"
                                                            name="traceabilityMou"
                                                            code="traceabilityMouCode"
                                                            description="traceabilityMouDesc"
                                                            setValue={
                                                              item?.traceabilityMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="traceabilityRemarks"
                                                            value={
                                                              item.traceabilityRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "traceabilityRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.traceabilityUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.traceabilityUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>

                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            4. Shrinkage And
                                                            Relaxation Process
                                                            With Documents
                                                            Available
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="shrinkageMou"
                                                            iconClassName="dropdownIcon"
                                                            name="shrinkageMou"
                                                            code="shrinkageMouCode"
                                                            description="shrinkageMouDesc"
                                                            setValue={
                                                              item?.shrinkageMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="shrinkageRemarks"
                                                            value={
                                                              item.shrinkageRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "shrinkageRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.shrinkageUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.shrinkageUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            4. Are Inspection
                                                            Records Kept And
                                                            Analysed
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="inspectionRecordsMou"
                                                            iconClassName="dropdownIcon"
                                                            name="inspectionRecordsMou"
                                                            code="inspectionRecordsMouCode"
                                                            description="inspectionRecordsMouDesc"
                                                            setValue={
                                                              item?.inspectionRecordsMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="inspectionRecordsRemarks"
                                                            value={
                                                              item.inspectionRecordsRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "inspectionRecordsRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.inspectionRecordsUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.inspectionRecordsUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            6.Fabric Approvals
                                                            On Shade And
                                                            Grouping?
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="fabricApprovalMou"
                                                            iconClassName="dropdownIcon"
                                                            name="fabricApprovalMou"
                                                            code="fabricApprovalMouCode"
                                                            description="fabricApprovalMouDesc"
                                                            setValue={
                                                              item?.fabricApprovalMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="fabricApprovalRemarks"
                                                            value={
                                                              item.fabricApprovalRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "fabricApprovalRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.fabricApprovalUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.fabricApprovalUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            7.Fabric Csv & Ssv
                                                            Checked Prior To
                                                            Bulk Cutting, Review
                                                            Past Records
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="fabricCsvMou"
                                                            iconClassName="dropdownIcon"
                                                            name="fabricCsvMou"
                                                            code="fabricCsvMouCode"
                                                            description="fabricCsvMouDesc"
                                                            setValue={
                                                              item?.fabricCsvMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="fabricCsvRemarks"
                                                            value={
                                                              item.fabricCsvRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "fabricCsvRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.fabricCsvUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.fabricCsvUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            8.Are Non-Conforming
                                                            Materials Identified
                                                            And Segregrated
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="materialsMou"
                                                            iconClassName="dropdownIcon"
                                                            name="materialsMou"
                                                            code="materialsMouCode"
                                                            description="materialsMouDesc"
                                                            setValue={
                                                              item?.materialsMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="materialsRemarks"
                                                            value={
                                                              item.materialsRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "materialsRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.materialsUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.materialsUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                    </div>
                                                  </Row>

                                                  {/* )
                                                                                      )}  */}
                                                </div>
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>
                                        <div className="d-flex-column justify-content-center">
                                          <Row>
                                            <Col xs={12} md={5} lg={5}>
                                              <h5 className="bg-table-status bg-table-warning-status mt-4">
                                                Trim and Accessories
                                              </h5>
                                            </Col>
                                            <Col xs={12}>
                                              <div className="accordion-body">
                                                <div className="d-flex-column justify-content-center">
                                                  <Row className="pt-4 d-none d-lg-flex ">
                                                    {/* <Col xs={12} md={2} lg={2}>
                                                                                          <p className="fs-6 fw-medium d-flex ms-4">
                                                                                            Are All The Panels Cut In The Factory
                                                                                          </p>
                                                                                        </Col> */}
                                                    <Col xs={12} md={4} lg={1}>
                                                      <p className="fs-6 fw-medium d-flex ms-4">
                                                        Questions
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex ms-4"></p>
                                                    </Col>

                                                    <Col xs={12} md={4} lg={4}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Remarks
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Upload Documents
                                                      </p>
                                                    </Col>
                                                  </Row>
                                                  {/* {item.getProjectCertifications.map(
                                                                                        (doc, itemIndex) => ( */}

                                                  <Row>
                                                    <div className="border p-3 rounded shadow-sm my-3">
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            1.Are MM Records
                                                            Kept And Analyzed
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="mmInpectorMou"
                                                            iconClassName="dropdownIcon"
                                                            name="mmInpectorMou"
                                                            code="mmInpectorMouCode"
                                                            description="mmInpectorMouDesc"
                                                            setValue={
                                                              item?.mmInpectorMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="mmInpectorRemarks"
                                                            value={
                                                              item.mmInpectorRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "mmInpectorRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.mmInpectorUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.mmInpectorUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            2. Is The Factory
                                                            Aware Of Their
                                                            CustomerS Lighting
                                                            Policy?
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="factoryAwareMou"
                                                            iconClassName="dropdownIcon"
                                                            name="factoryAwareMou"
                                                            code="factoryAwareMouCode"
                                                            description="factoryAwareMouDesc"
                                                            setValue={
                                                              item?.factoryAwareMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="factoryAwareRemarks"
                                                            name="factoryAwareRemarks"
                                                            value={
                                                              item.factoryAwareRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "factoryAwareRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.factoryAwareUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.factoryAwareUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            3. Trim Approval
                                                            Process Before
                                                            Production Or
                                                            Duplication
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="trimApprovalMou"
                                                            iconClassName="dropdownIcon"
                                                            name="trimApprovalMou"
                                                            code="trimApprovalMouCode"
                                                            description="trimApprovalMouDesc"
                                                            setValue={
                                                              item?.trimApprovalMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="trimApprovalRemarks"
                                                            value={
                                                              item.trimApprovalRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "trimApprovalRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.trimApprovalUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.trimApprovalUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>

                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            4. Are
                                                            Non-Conforming
                                                            Materials Being
                                                            Identified And
                                                            Segregrated?
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="factoryShrinkageMou"
                                                            iconClassName="dropdownIcon"
                                                            name="areNonConfirmingMou"
                                                            code="areNonConfirmingMouCode"
                                                            description="areNonConfirmingMouDesc"
                                                            setValue={
                                                              item?.areNonConfirmingMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="areNonConfirmingRemarks"
                                                            value={
                                                              item.areNonConfirmingRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "areNonConfirmingRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.areNonConfirmingUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.areNonConfirmingUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                    </div>
                                                  </Row>

                                                  {/* )
                                                                                      )}  */}
                                                </div>
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>
                                        <div className="d-flex-column justify-content-center">
                                          <Row>
                                            <Col xs={12} md={5} lg={5}>
                                              <h5 className="bg-table-status bg-table-warning-status mt-4">
                                                Label Management
                                              </h5>
                                            </Col>
                                            <Col xs={12}>
                                              <div className="accordion-body">
                                                <div className="d-flex-column justify-content-center">
                                                  <Row className="pt-4 d-none d-lg-flex ">
                                                    {/* <Col xs={12} md={2} lg={2}>
                                                                                          <p className="fs-6 fw-medium d-flex ms-4">
                                                                                            Are All The Panels Cut In The Factory
                                                                                          </p>
                                                                                        </Col> */}
                                                    <Col xs={12} md={4} lg={1}>
                                                      <p className="fs-6 fw-medium d-flex ms-4">
                                                        Questions
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex ms-4"></p>
                                                    </Col>

                                                    <Col xs={12} md={4} lg={4}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Remarks
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Upload Documents
                                                      </p>
                                                    </Col>
                                                  </Row>
                                                  {/* {item.getProjectCertifications.map(
                                                                                        (doc, itemIndex) => ( */}

                                                  <Row>
                                                    <div className="border p-3 rounded shadow-sm my-3">
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            1.Do All Labels Are
                                                            Checked And Hangtags
                                                            Validated And
                                                            Checked
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="labelsMou"
                                                            iconClassName="dropdownIcon"
                                                            name="labelsMou"
                                                            code="labelsMouCode"
                                                            description="labelsMouDesc"
                                                            setValue={
                                                              item?.labelsMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="labelsRemarks"
                                                            value={
                                                              item.labelsRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "labelsRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.labelsUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.labelsUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            2.Is There A
                                                            Designated Area For
                                                            Labels?
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="designatedAreaMou"
                                                            iconClassName="dropdownIcon"
                                                            name="designatedAreaMou"
                                                            code="designatedAreaMouCode"
                                                            description="designatedAreaMouDesc"
                                                            setValue={
                                                              item?.designatedAreaMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="designatedAreaRemarks"
                                                            name="designatedAreaRemarks"
                                                            value={
                                                              item.designatedAreaRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "designatedAreaRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.designatedAreaUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.designatedAreaUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            3. Labelling Issuing
                                                            Record/ Traceable
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="labelingIssuingMou"
                                                            iconClassName="dropdownIcon"
                                                            name="labelingIssuingMou"
                                                            code="labelingIssuingMouCode"
                                                            description="labelingIssuingMouDesc"
                                                            setValue={
                                                              item?.labelingIssuingMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="labelingIssuingRemarks"
                                                            value={
                                                              item.labelingIssuingRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "labelingIssuingRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.labelingIssuingUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.labelingIssuingUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>

                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            4. Are Label And
                                                            Price Tickets Stored
                                                            Securely?
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="priceTicketsMou"
                                                            iconClassName="dropdownIcon"
                                                            name="priceTicketsMou"
                                                            code="priceTicketsMouCode"
                                                            description="priceTicketsMouDesc"
                                                            setValue={
                                                              item?.priceTicketsMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="priceTicketsRemarks"
                                                            value={
                                                              item.priceTicketsRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "priceTicketsRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.priceTicketsUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.priceTicketsUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            5. Are Extra Labels
                                                            Returned To Stores?
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="extraLabelsMou"
                                                            iconClassName="dropdownIcon"
                                                            name="extraLabelsMou"
                                                            code="extraLabelsMouCode"
                                                            description="extraLabelsMouDesc"
                                                            setValue={
                                                              item?.extraLabelsMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="extraLabelsRemarks"
                                                            value={
                                                              item.extraLabelsRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "extraLabelsRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.extraLabelsUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.extraLabelsUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                    </div>
                                                  </Row>

                                                  {/* )
                                                                                      )}  */}
                                                </div>
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>
                                        <div className="d-flex-column justify-content-center">
                                          <Row>
                                            <Col xs={12} md={5} lg={5}>
                                              <h4 className="mt-5 font-bold text-lg">
                                                Preproduction
                                              </h4>
                                              <h5 className="bg-table-status bg-table-warning-status mt-4">
                                                Pattern Room Management
                                              </h5>
                                            </Col>
                                            <Col xs={12}>
                                              <div className="accordion-body">
                                                <div className="d-flex-column justify-content-center">
                                                  <Row className="pt-4 d-none d-lg-flex ">
                                                    {/* <Col xs={12} md={2} lg={2}>
                                                                                          <p className="fs-6 fw-medium d-flex ms-4">
                                                                                            Are All The Panels Cut In The Factory
                                                                                          </p>
                                                                                        </Col> */}
                                                    <Col xs={12} md={4} lg={1}>
                                                      <p className="fs-6 fw-medium d-flex ms-4">
                                                        Questions
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex ms-4"></p>
                                                    </Col>

                                                    <Col xs={12} md={4} lg={4}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Remarks
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Upload Documents
                                                      </p>
                                                    </Col>
                                                  </Row>
                                                  {/* {item.getProjectCertifications.map(
                                                                                        (doc, itemIndex) => ( */}

                                                  <Row>
                                                    <div className="border p-3 rounded shadow-sm my-3">
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            1.Does Vendor Has
                                                            Capability Of
                                                            Developiong Their
                                                            Own Pattern -Cad?
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="vendorMou"
                                                            iconClassName="dropdownIcon"
                                                            name="vendorMou"
                                                            code="vendorMouCode"
                                                            description="vendorMouDesc"
                                                            setValue={
                                                              item?.vendorMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="vendorRemarks"
                                                            value={
                                                              item.vendorRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "vendorRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.vendorUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.vendorUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            2. Is There Clear
                                                            Records Of The Date
                                                            And Changes To
                                                            Patterns
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="clearRecordsMou"
                                                            iconClassName="dropdownIcon"
                                                            name="clearRecordsMou"
                                                            code="clearRecordsMouCode"
                                                            description="clearRecordsMouDesc"
                                                            setValue={
                                                              item?.clearRecordsMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="clearRecordsRemarks"
                                                            name="clearRecordsRemarks"
                                                            value={
                                                              item.clearRecordsRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "clearRecordsRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.clearRecordsUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.clearRecordsUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            3. Are Patterns Been
                                                            Validated With Ho
                                                            Cad
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="pattrensValidateMou"
                                                            iconClassName="dropdownIcon"
                                                            name="pattrensValidateMou"
                                                            code="pattrensValidateMouCode"
                                                            description="pattrensValidateMouDesc"
                                                            setValue={
                                                              item?.pattrensValidateMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="pattrensValidateRemarks"
                                                            value={
                                                              item.pattrensValidateRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "pattrensValidateRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.pattrensValidateUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.pattrensValidateUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>

                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            4. Does The Factory
                                                            Adds Shrinkage On
                                                            Pattern Based On
                                                            Bulk Fabric
                                                            Shrinkages
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="factoryShrinkageMou"
                                                            iconClassName="dropdownIcon"
                                                            name="factoryShrinkageMou"
                                                            code="factoryShrinkageMouCode"
                                                            description="factoryShrinkageMouDesc"
                                                            setValue={
                                                              item?.factoryShrinkageMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="factoryShrinkageRemarks"
                                                            value={
                                                              item.factoryShrinkageRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "factoryShrinkageRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.factoryShrinkageUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.factoryShrinkageUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            5. Are There Any
                                                            Before Wash
                                                            Measurement Size
                                                            Chart Maintained
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="measurementSizeMou"
                                                            iconClassName="dropdownIcon"
                                                            name="measurementSizeMou"
                                                            code="measurementSizeMouCode"
                                                            description="measurementSizeMouDesc"
                                                            setValue={
                                                              item?.measurementSizeMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="measurementSizeRemarks"
                                                            value={
                                                              item.measurementSizeRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "measurementSizeRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.measurementSizeUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.measurementSizeUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                    </div>
                                                  </Row>

                                                  {/* )
                                                                                      )}  */}
                                                </div>
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>
                                        <div className="d-flex-column justify-content-center">
                                          <Row>
                                            <Col xs={12} md={5} lg={5}>
                                              <h5 className="bg-table-status bg-table-warning-status mt-4">
                                                Production Planning
                                              </h5>
                                            </Col>
                                            <Col xs={12}>
                                              <div className="accordion-body">
                                                <div className="d-flex-column justify-content-center">
                                                  <Row className="pt-4 d-none d-lg-flex ">
                                                    {/* <Col xs={12} md={2} lg={2}>
                                                                                          <p className="fs-6 fw-medium d-flex ms-4">
                                                                                            Are All The Panels Cut In The Factory
                                                                                          </p>
                                                                                        </Col> */}
                                                    <Col xs={12} md={4} lg={1}>
                                                      <p className="fs-6 fw-medium d-flex ms-4">
                                                        Questions
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex ms-4"></p>
                                                    </Col>

                                                    <Col xs={12} md={4} lg={4}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Remarks
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Upload Documents
                                                      </p>
                                                    </Col>
                                                  </Row>
                                                  {/* {item.getProjectCertifications.map(
                                                                                        (doc, itemIndex) => ( */}

                                                  <Row>
                                                    <div className="border p-3 rounded shadow-sm my-3">
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            1.Is There A
                                                            Critical Path Plan
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="criticalMou"
                                                            iconClassName="dropdownIcon"
                                                            name="criticalMou"
                                                            code="criticalMouCode"
                                                            description="criticalMouDesc"
                                                            setValue={
                                                              item?.criticalMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="criticalRemarks"
                                                            value={
                                                              item.criticalRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "criticalRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.criticalUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.criticalUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            2. Are There
                                                            Daily/Weekly Targets
                                                            Set For The Sewing
                                                            Line
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="sewingLineMou"
                                                            iconClassName="dropdownIcon"
                                                            name="sewingLineMou"
                                                            code="sewingLineMouCode"
                                                            description="sewingLineMouDesc"
                                                            setValue={
                                                              item?.sewingLineMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="sewingLineRemarks"
                                                            name="sewingLineRemarks"
                                                            value={
                                                              item.sewingLineRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "sewingLineRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.sewingLineUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.sewingLineUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            3. How Is The Target
                                                            Level Being
                                                            Calculated
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="levelBeingMou"
                                                            iconClassName="dropdownIcon"
                                                            name="levelBeingMou"
                                                            code="levelBeingMouCode"
                                                            description="levelBeingMouDesc"
                                                            setValue={
                                                              item?.levelBeingMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="levelBeingRemarks"
                                                            value={
                                                              item.levelBeingRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "levelBeingRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.levelBeingUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.levelBeingUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>

                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            4. Are Pilot Run
                                                            Produced /Carried
                                                            Out
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="carriedOutMou"
                                                            iconClassName="dropdownIcon"
                                                            name="carriedOutMou"
                                                            code="carriedOutMouCode"
                                                            description="carriedOutMouDesc"
                                                            setValue={
                                                              item?.carriedOutMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="carriedOutRemarks"
                                                            value={
                                                              item.carriedOutRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "carriedOutRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.carriedOutUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.carriedOutUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            5. Will A
                                                            PreProduction
                                                            Meeting Be Carried
                                                            Before Production
                                                            Start?
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="productionStartMou"
                                                            iconClassName="dropdownIcon"
                                                            name="productionStartMou"
                                                            code="productionStartMouCode"
                                                            description="productionStartMouDesc"
                                                            setValue={
                                                              item?.productionStartMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="productionStartRemarks"
                                                            value={
                                                              item.productionStartRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "productionStartRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.productionStartUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.productionStartUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            5. Is There Any
                                                            Action Plan/ Record
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="planRecordMou"
                                                            iconClassName="dropdownIcon"
                                                            name="planRecordMou"
                                                            code="planRecordMouCode"
                                                            description="planRecordMouDesc"
                                                            setValue={
                                                              item?.planRecordMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="planRecordRemarks"
                                                            value={
                                                              item.planRecordRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "planRecordRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.planRecordUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.planRecordUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                    </div>
                                                  </Row>

                                                  {/* )
                                                                                      )}  */}
                                                </div>
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>
                                        <div className="d-flex-column justify-content-center">
                                          <Row>
                                            <Col xs={12} md={5} lg={5}>
                                              <h4 className="mt-5 font-bold text-lg">
                                                Cutting Room
                                              </h4>
                                              <h5 className="bg-table-status bg-table-warning-status mt-4">
                                                In House Cutting
                                              </h5>
                                            </Col>
                                            <Col xs={12}>
                                              <div className="accordion-body">
                                                <div className="d-flex-column justify-content-center">
                                                  <Row className="pt-4 d-none d-lg-flex ">
                                                    {/* <Col xs={12} md={2} lg={2}>
                                                                                          <p className="fs-6 fw-medium d-flex ms-4">
                                                                                            Are All The Panels Cut In The Factory
                                                                                          </p>
                                                                                        </Col> */}
                                                    <Col xs={12} md={4} lg={1}>
                                                      <p className="fs-6 fw-medium d-flex ms-4">
                                                        Questions
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex ms-4"></p>
                                                    </Col>

                                                    <Col xs={12} md={4} lg={4}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Remarks
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Upload Documents
                                                      </p>
                                                    </Col>
                                                  </Row>
                                                  {/* {item.getProjectCertifications.map(
                                                                                        (doc, itemIndex) => ( */}

                                                  <Row>
                                                    <div className="border p-3 rounded shadow-sm my-3">
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            1.How Is Marker
                                                            Attached To The Lay?
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="markerAttachedMou"
                                                            iconClassName="dropdownIcon"
                                                            name="markerAttachedMou"
                                                            code="markerAttachedMouCode"
                                                            description="markerAttachedMouDesc"
                                                            setValue={
                                                              item?.markerAttachedMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="markerAttachedRemarks"
                                                            value={
                                                              item.markerAttachedRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "markerAttachedRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.markerAttachedUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.markerAttachedUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            2.Lay Spreading
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="laySpreadingMou"
                                                            iconClassName="dropdownIcon"
                                                            name="laySpreadingMou"
                                                            code="laySpreadingMouCode"
                                                            description="laySpreadingMouDesc"
                                                            setValue={
                                                              item?.laySpreadingMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="laySpreadingRemarks"
                                                            name="laySpreadingRemarks"
                                                            value={
                                                              item.laySpreadingRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "laySpreadingRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.laySpreadingUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.laySpreadingUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            3.No. Of Cutting
                                                            Tables
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="cuttingTablesMou"
                                                            iconClassName="dropdownIcon"
                                                            name="cuttingTablesMou"
                                                            code="cuttingTablesMouCode"
                                                            description="cuttingTablesMouDesc"
                                                            setValue={
                                                              item?.cuttingTablesMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="cuttingTablesRemarks"
                                                            value={
                                                              item.cuttingTablesRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "cuttingTablesRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.cuttingTablesUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.cuttingTablesUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>

                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            4. Straight Knife
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="straightKnifeMou"
                                                            iconClassName="dropdownIcon"
                                                            name="straightKnifeMou"
                                                            code="straightKnifeMouCode"
                                                            description="straightKnifeMouDesc"
                                                            setValue={
                                                              item?.straightKnifeMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="straightKnifeRemarks"
                                                            value={
                                                              item.straightKnifeRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "straightKnifeRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.straightKnifeUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.straightKnifeUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            5. Round Knife
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="roundKnifeMou"
                                                            iconClassName="dropdownIcon"
                                                            name="roundKnifeMou"
                                                            code="roundKnifeMouCode"
                                                            description="roundKnifeMouDesc"
                                                            setValue={
                                                              item?.roundKnifeMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="roundKnifeRemarks"
                                                            value={
                                                              item.roundKnifeRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "roundKnifeRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.roundKnifeUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.roundKnifeUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            6. Band Knife
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="bandKnifeMou"
                                                            iconClassName="dropdownIcon"
                                                            name="bandKnifeMou"
                                                            code="bandKnifeMouCode"
                                                            description="bandKnifeMouDesc"
                                                            setValue={
                                                              item?.bandKnifeMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="bandKnifeRemarks"
                                                            value={
                                                              item.bandKnifeRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "bandKnifeRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.bandKnifeUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.bandKnifeUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            7.Edge Cutter
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="edgeCutterMou"
                                                            iconClassName="dropdownIcon"
                                                            name="edgeCutterMou"
                                                            code="edgeCutterMouCode"
                                                            description="edgeCutterMouDesc"
                                                            setValue={
                                                              item?.edgeCutterMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="edgeCutterRemarks"
                                                            value={
                                                              item.edgeCutterRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "edgeCutterRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.edgeCutterUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.edgeCutterUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            7.Computer Cutting
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="computerCuttingMou"
                                                            iconClassName="dropdownIcon"
                                                            name="computerCuttingMou"
                                                            code="computerCuttingMouCode"
                                                            description="computerCuttingMouDesc"
                                                            setValue={
                                                              item?.computerCuttingMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="computerCuttingRemarks"
                                                            value={
                                                              item.computerCuttingRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "computerCuttingRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.computerCuttingUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.computerCuttingUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            9.Die Cutter
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="dieCutterMou"
                                                            iconClassName="dropdownIcon"
                                                            name="dieCutterMou"
                                                            code="dieCutterMouCode"
                                                            description="dieCutterMouDesc"
                                                            setValue={
                                                              item?.dieCutterMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="dieCutterRemarks"
                                                            value={
                                                              item.dieCutterRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "dieCutterRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.dieCutterUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.dieCutterUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            10.Others
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="otherMou"
                                                            iconClassName="dropdownIcon"
                                                            name="otherMou"
                                                            code="otherMouCode"
                                                            description="otherMouDesc"
                                                            setValue={
                                                              item?.otherMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="otherRemarks"
                                                            value={
                                                              item.otherRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "otherRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.otherUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.otherUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            10.Condition Of
                                                            Equipment:
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="equipmentMou"
                                                            iconClassName="dropdownIcon"
                                                            name="equipmentMou"
                                                            code="equipmentMouCode"
                                                            description="equipmentMouDesc"
                                                            setValue={
                                                              item?.equipmentMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="equipmentRemarks"
                                                            value={
                                                              item.equipmentRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "equipmentRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.equipmentUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.equipmentUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                    </div>
                                                  </Row>

                                                  {/* )
                                                                                      )}  */}
                                                </div>
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>
                                        <div className="d-flex-column justify-content-center">
                                          <Row>
                                            <Col xs={12} md={5} lg={5}>
                                              <h5 className="bg-table-status bg-table-warning-status mt-4">
                                                A2.QUALITY CONTROL SYSTEM
                                              </h5>
                                            </Col>
                                            <Col xs={12}>
                                              <div className="accordion-body">
                                                <div className="d-flex-column justify-content-center">
                                                  <Row className="pt-4 d-none d-lg-flex ">
                                                    {/* <Col xs={12} md={2} lg={2}>
                                                                                          <p className="fs-6 fw-medium d-flex ms-4">
                                                                                            Are All The Panels Cut In The Factory
                                                                                          </p>
                                                                                        </Col> */}
                                                    <Col xs={12} md={4} lg={1}>
                                                      <p className="fs-6 fw-medium d-flex ms-4">
                                                        Questions
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex ms-4"></p>
                                                    </Col>

                                                    <Col xs={12} md={4} lg={4}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Remarks
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Upload Documents
                                                      </p>
                                                    </Col>
                                                  </Row>
                                                  {/* {item.getProjectCertifications.map(
                                                                                        (doc, itemIndex) => ( */}

                                                  <Row>
                                                    <div className="border p-3 rounded shadow-sm my-3">
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            1.Colour Continuity
                                                            Card/Shade Bands
                                                            Record
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="colorMou"
                                                            iconClassName="dropdownIcon"
                                                            name="colorMou"
                                                            code="colorMouCode"
                                                            description="colorMouDesc"
                                                            setValue={
                                                              item?.colorMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="colorRemarks"
                                                            value={
                                                              item.colorRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "colorRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.colorUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.colorUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            2.Cpl Process Is
                                                            Available
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="cplProcessMou"
                                                            iconClassName="dropdownIcon"
                                                            name="cplProcessMou"
                                                            code="cplProcessMouCode"
                                                            description="cplProcessMouDesc"
                                                            setValue={
                                                              item?.cplProcessMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="cplProcessRemarks"
                                                            name="cplProcessRemarks"
                                                            value={
                                                              item.cplProcessRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "cplProcessRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.cplProcessUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.cplProcessUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            3.Traceability Of
                                                            Shades Of Use Of
                                                            Fabric Dye Lot No?
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="fabricDyeLotNoMou"
                                                            iconClassName="dropdownIcon"
                                                            name="fabricDyeLotNoMou"
                                                            code="fabricDyeLotNoMouCode"
                                                            description="fabricDyeLotNoMouDesc"
                                                            setValue={
                                                              item?.fabricDyeLotNoMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="fabricDyeLotNoRemarks"
                                                            value={
                                                              item.fabricDyeLotNoRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "fabricDyeLotNoRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.fabricDyeLotNoUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.fabricDyeLotNoUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>

                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            4. Separating Roll
                                                            By Paper/ Waste
                                                            Fabric Strips
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="fabricStripsMou"
                                                            iconClassName="dropdownIcon"
                                                            name="fabricStripsMou"
                                                            code="fabricStripsMouCode"
                                                            description="fabricStripsMouDesc"
                                                            setValue={
                                                              item?.fabricStripsMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="fabricStripsRemarks"
                                                            value={
                                                              item.fabricStripsRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "fabricStripsRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.fabricStripsUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.fabricStripsUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            5. Are Panels
                                                            Numbered
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="panelsNumberedMou"
                                                            iconClassName="dropdownIcon"
                                                            name="panelsNumberedMou"
                                                            code="panelsNumberedMouCode"
                                                            description="panelsNumberedMouDesc"
                                                            setValue={
                                                              item?.panelsNumberedMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="panelsNumberedRemarks"
                                                            value={
                                                              item.panelsNumberedRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "panelsNumberedRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.panelsNumberedUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.panelsNumberedUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            6. Are
                                                            Bundles/Panels
                                                            Inspected
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="bundlesPanelMou"
                                                            iconClassName="dropdownIcon"
                                                            name="bundlesPanelMou"
                                                            code="bundlesPanelMouCode"
                                                            description="bundlesPanelMouDesc"
                                                            setValue={
                                                              item?.bundlesPanelMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="bundlesPanelRemarks"
                                                            value={
                                                              item.bundlesPanelRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "bundlesPanelRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.bundlesPanelUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.bundlesPanelUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            7.Are There Any
                                                            Bundle/ Panel
                                                            Inspection Records
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="bundleInspectionMou"
                                                            iconClassName="dropdownIcon"
                                                            name="bundleInspectionMou"
                                                            code="bundleInspectionMouCode"
                                                            description="bundleInspectionMouDesc"
                                                            setValue={
                                                              item?.bundleInspectionMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="bundleInspectionRemarks"
                                                            value={
                                                              item.bundleInspectionRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "bundleInspectionRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.bundleInspectionUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.bundleInspectionUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            8.Overcut Under
                                                            Tolerance
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="overCutUnderMou"
                                                            iconClassName="dropdownIcon"
                                                            name="overCutUnderMou"
                                                            code="overCutUnderMouCode"
                                                            description="overCutUnderMouDesc"
                                                            setValue={
                                                              item?.overCutUnderMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="overCutUnderRemarks"
                                                            value={
                                                              item.overCutUnderRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "overCutUnderRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.overCutUnderUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.overCutUnderUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            9.Is There Any Lay
                                                            Relaxation Process
                                                            And Record
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="layRelaxationMou"
                                                            iconClassName="dropdownIcon"
                                                            name="layRelaxationMou"
                                                            code="layRelaxationMouCode"
                                                            description="layRelaxationMouDesc"
                                                            setValue={
                                                              item?.layRelaxationMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="layRelaxationRemarks"
                                                            value={
                                                              item.layRelaxationRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "layRelaxationRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.layRelaxationUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.layRelaxationUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            10.Is There A
                                                            Quality Check Report
                                                            For Top Middle
                                                            Bottom Panel
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="qualityCheckedMou"
                                                            iconClassName="dropdownIcon"
                                                            name="qualityCheckedMou"
                                                            code="qualityCheckedMouCode"
                                                            description="qualityCheckedMouDesc"
                                                            setValue={
                                                              item?.qualityCheckedMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="qualityCheckedRemarks"
                                                            value={
                                                              item.qualityCheckedRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "qualityCheckedRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.qualityCheckedUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.qualityCheckedUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            11.Are Embroidery
                                                            Panels Checked
                                                            /Print /Ht Are
                                                            Checked 100%
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="embroideryPanelsMou"
                                                            iconClassName="dropdownIcon"
                                                            name="embroideryPanelsMou"
                                                            code="embroideryPanelsMouCode"
                                                            description="embroideryPanelsMouDesc"
                                                            setValue={
                                                              item?.embroideryPanelsMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="embroideryPanelsRemarks"
                                                            value={
                                                              item.embroideryPanelsRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "embroideryPanelsRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.embroideryPanelsUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.embroideryPanelsUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            12. Alll Patterns
                                                            Must Be Sealed
                                                            Internally
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="sealedInternellyMou"
                                                            iconClassName="dropdownIcon"
                                                            name="sealedInternellyMou"
                                                            code="sealedInternellyMouCode"
                                                            description="sealedInternellyMouDesc"
                                                            setValue={
                                                              item?.sealedInternellyMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="sealedInternellyRemarks"
                                                            value={
                                                              item.sealedInternellyRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "sealedInternellyRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.sealedInternellyUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.sealedInternellyUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                    </div>
                                                  </Row>

                                                  {/* )
                                                                                      )}  */}
                                                </div>
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>
                                        <div className="d-flex-column justify-content-center">
                                          <Row>
                                            <Col xs={12} md={5} lg={5}>
                                              <h4 className="mt-5 font-bold text-lg">
                                                Fusing
                                              </h4>

                                              <h5 className="bg-table-status bg-table-warning-status mt-4">
                                                Fusing Machinery
                                              </h5>
                                            </Col>
                                            <Col xs={12}>
                                              <div className="accordion-body">
                                                <div className="d-flex-column justify-content-center">
                                                  <Row className="pt-4 d-none d-lg-flex ">
                                                    {/* <Col xs={12} md={2} lg={2}>
                                                                                          <p className="fs-6 fw-medium d-flex ms-4">
                                                                                            Are All The Panels Cut In The Factory
                                                                                          </p>
                                                                                        </Col> */}
                                                    <Col xs={12} md={4} lg={1}>
                                                      <p className="fs-6 fw-medium d-flex ms-4">
                                                        Questions
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex ms-4"></p>
                                                    </Col>

                                                    <Col xs={12} md={4} lg={4}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Remarks
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Upload Documents
                                                      </p>
                                                    </Col>
                                                  </Row>
                                                  {/* {item.getProjectCertifications.map(
                                                                                        (doc, itemIndex) => ( */}

                                                  <Row>
                                                    <div className="border p-3 rounded shadow-sm my-3">
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            1.Fusing Machine
                                                            Make
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="fusingMachineMou"
                                                            iconClassName="dropdownIcon"
                                                            name="fusingMachineMou"
                                                            code="fusingMachineMouCode"
                                                            description="fusingMachineMouDesc"
                                                            setValue={
                                                              item?.fusingMachineMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="fusingMachineRemarks"
                                                            value={
                                                              item.fusingMachineRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "fusingMachineRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.fusingMachineUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.fusingMachineUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            2.Number Of Machines
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="noOfFusingMachineMou"
                                                            iconClassName="dropdownIcon"
                                                            name="noOfFusingMachineMou"
                                                            code="noOfFusingMachineMouCode"
                                                            description="noOfFusingMachineMouDesc"
                                                            setValue={
                                                              item?.noOfFusingMachineMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="noOfFusingMachineRemarks"
                                                            name="noOfFusingMachineRemarks"
                                                            value={
                                                              item.noOfFusingMachineRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "noOfFusingMachineRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.noOfFusingMachineUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.noOfFusingMachineUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            3.Is Fusing
                                                            (Thermal) Shrinkage
                                                            Checked?
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="thermalShrincageMou"
                                                            iconClassName="dropdownIcon"
                                                            name="thermalShrincageMou"
                                                            code="thermalShrincageMouCode"
                                                            description="thermalShrincageMouDesc"
                                                            setValue={
                                                              item?.thermalShrincageMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="thermalShrincageRemarks"
                                                            value={
                                                              item.thermalShrincageRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "thermalShrincageRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.thermalShrincageUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.thermalShrincageUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>

                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            4. Are Records Kept
                                                            Of Fusing Condition
                                                            Checks?
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="fusingRecordsMou"
                                                            iconClassName="dropdownIcon"
                                                            name="fusingRecordsMou"
                                                            code="fusingRecordsMouCode"
                                                            description="fusingRecordsMouDesc"
                                                            setValue={
                                                              item?.fusingRecordsMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="fusingRecordsRemarks"
                                                            value={
                                                              item.fusingRecordsRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "fusingRecordsRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.fusingRecordsUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.fusingRecordsUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            5. Does Factory Have
                                                            A Maintenance
                                                            Schedule For These
                                                            Machines?
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="fusingSheduleMou"
                                                            iconClassName="dropdownIcon"
                                                            name="fusingSheduleMou"
                                                            code="fusingSheduleMouCode"
                                                            description="fusingSheduleMouDesc"
                                                            setValue={
                                                              item?.fusingSheduleMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="fusingSheduleRemarks"
                                                            value={
                                                              item.fusingSheduleRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "fusingSheduleRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.fusingSheduleUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.fusingSheduleUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            6. Frequecny Of
                                                            Maintenance Is
                                                            Acceptable
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="fusingmainanceMou"
                                                            iconClassName="dropdownIcon"
                                                            name="fusingmainanceMou"
                                                            code="fusingmainanceMouCode"
                                                            description="fusingmainanceMouDesc"
                                                            setValue={
                                                              item?.fusingmainanceMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="fusingmainanceRemarks"
                                                            value={
                                                              item.fusingmainanceRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "fusingmainanceRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.fusingmainanceUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.fusingmainanceUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            7.Machine
                                                            Calibration
                                                            Frequency Been
                                                            Validated By Thrid
                                                            Party
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="fusingCalibrationMou"
                                                            iconClassName="dropdownIcon"
                                                            name="fusingCalibrationMou"
                                                            code="fusingCalibrationMouCode"
                                                            description="fusingCalibrationMouDesc"
                                                            setValue={
                                                              item?.fusingCalibrationMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="fusingCalibrationRemarks"
                                                            value={
                                                              item.fusingCalibrationRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "fusingCalibrationRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.fusingCalibrationUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.fusingCalibrationUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            8.Is Fuse Line
                                                            Temperature/Pressu
                                                            re Evenness Dwell
                                                            Time Available
                                                            Daily?
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="fuselineTemperatureMou"
                                                            iconClassName="dropdownIcon"
                                                            name="fuselineTemperatureMou"
                                                            code="fuselineTemperatureMouCode"
                                                            description="fuselineTemperatureMouDesc"
                                                            setValue={
                                                              item?.fuselineTemperatureMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="fuselineTemperatureRemarks"
                                                            value={
                                                              item.fuselineTemperatureRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "fuselineTemperatureRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.fuselineTemperatureUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.fuselineTemperatureUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            9.Fabric Specific
                                                            Fusing Recomendation
                                                            Available From
                                                            Supplier Checked
                                                            Prior To Fusing?
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="fusingFabricMou"
                                                            iconClassName="dropdownIcon"
                                                            name="fusingFabricMou"
                                                            code="fusingFabricMouCode"
                                                            description="fusingFabricMouDesc"
                                                            setValue={
                                                              item?.fusingFabricMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="fusingFabricRemarks"
                                                            value={
                                                              item.fusingFabricRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "fusingFabricRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.fusingFabricUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.fusingFabricUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            10.Is Peel Bond
                                                            Strength Checked
                                                            Before And After
                                                            Wash
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="fusingPeelMou"
                                                            iconClassName="dropdownIcon"
                                                            name="fusingPeelMou"
                                                            code="fusingPeelMouCode"
                                                            description="fusingPeelMouDesc"
                                                            setValue={
                                                              item?.fusingPeelMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="fusingPeelRemarks"
                                                            value={
                                                              item.fusingPeelRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "fusingPeelRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.fusingPeelUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.fusingPeelUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                    </div>
                                                  </Row>

                                                  {/* )
                                                                                      )}  */}
                                                </div>
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>
                                        <div className="d-flex-column justify-content-center">
                                          <Row>
                                            <Col xs={12} md={5} lg={5}>
                                              <h4 className="mt-5 font-bold text-lg">
                                                Sewing Room
                                              </h4>

                                              <h5 className="bg-table-status bg-table-warning-status mt-4">
                                                Sewing Line Set Up
                                              </h5>
                                            </Col>
                                            <Col xs={12}>
                                              <div className="accordion-body">
                                                <div className="d-flex-column justify-content-center">
                                                  <Row className="pt-4 d-none d-lg-flex ">
                                                    {/* <Col xs={12} md={2} lg={2}>
                                                                                          <p className="fs-6 fw-medium d-flex ms-4">
                                                                                            Are All The Panels Cut In The Factory
                                                                                          </p>
                                                                                        </Col> */}
                                                    <Col xs={12} md={4} lg={1}>
                                                      <p className="fs-6 fw-medium d-flex ms-4">
                                                        Questions
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex ms-4"></p>
                                                    </Col>

                                                    <Col xs={12} md={4} lg={4}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Remarks
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Upload Documents
                                                      </p>
                                                    </Col>
                                                  </Row>
                                                  {/* {item.getProjectCertifications.map(
                                                                                        (doc, itemIndex) => ( */}

                                                  <Row>
                                                    <div className="border p-3 rounded shadow-sm my-3">
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            1.Are Approval
                                                            Samples /Critical
                                                            Mocks Displayed N
                                                            The Sewing Lines?
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="sewingApprovalMou"
                                                            iconClassName="dropdownIcon"
                                                            name="sewingApprovalMou"
                                                            code="sewingApprovalMouCode"
                                                            description="sewingApprovalMouDesc"
                                                            setValue={
                                                              item?.sewingApprovalMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="sewingApprovalRemarks"
                                                            value={
                                                              item.sewingApprovalRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "sewingApprovalRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.sewingApprovalUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.sewingApprovalUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            2.Are Internal
                                                            Approved Trim Card
                                                            Available In Sewing
                                                            Line?
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="sewingRoomIntervalMou"
                                                            iconClassName="dropdownIcon"
                                                            name="sewingRoomIntervalMou"
                                                            code="sewingRoomIntervalMouCode"
                                                            description="sewingRoomIntervalMouDesc"
                                                            setValue={
                                                              item?.sewingRoomIntervalMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="sewingRoomIntervalRemarks"
                                                            name="sewingRoomIntervalRemarks"
                                                            value={
                                                              item.sewingRoomIntervalRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "sewingRoomIntervalRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.sewingRoomIntervalUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.sewingRoomIntervalUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            3.Proper Attachments
                                                            ( Presser Foots,
                                                            Folders, Guides And
                                                            Templates ) And
                                                            Other Working Aids
                                                            Are Installed And
                                                            Utilized By The
                                                            Operators.
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="sewingRoomoperatorsMou"
                                                            iconClassName="dropdownIcon"
                                                            name="sewingRoomoperatorsMou"
                                                            code="sewingRoomoperatorsMouCode"
                                                            description="sewingRoomoperatorsMouDesc"
                                                            setValue={
                                                              item?.sewingRoomoperatorsMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="sewingRoomoperatorsRemarks"
                                                            value={
                                                              item.sewingRoomoperatorsRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "sewingRoomoperatorsRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.sewingRoomoperatorsUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.sewingRoomoperatorsUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                    </div>
                                                  </Row>

                                                  {/* )
                                                                                      )}  */}
                                                </div>
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>
                                        <div className="d-flex-column justify-content-center">
                                          <Row>
                                            <Col xs={12} md={5} lg={5}>
                                              {/* <h4 className="mt-5 font-bold text-lg">
                                                                                    Sewing Room
                                                                                  </h4> */}

                                              <h5 className="bg-table-status bg-table-warning-status mt-4">
                                                Label Mangement
                                              </h5>
                                            </Col>
                                            <Col xs={12}>
                                              <div className="accordion-body">
                                                <div className="d-flex-column justify-content-center">
                                                  <Row className="pt-4 d-none d-lg-flex ">
                                                    {/* <Col xs={12} md={2} lg={2}>
                                                                                          <p className="fs-6 fw-medium d-flex ms-4">
                                                                                            Are All The Panels Cut In The Factory
                                                                                          </p>
                                                                                        </Col> */}
                                                    <Col xs={12} md={4} lg={1}>
                                                      <p className="fs-6 fw-medium d-flex ms-4">
                                                        Questions
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex ms-4"></p>
                                                    </Col>

                                                    <Col xs={12} md={4} lg={4}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Remarks
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Upload Documents
                                                      </p>
                                                    </Col>
                                                  </Row>
                                                  {/* {item.getProjectCertifications.map(
                                                                                        (doc, itemIndex) => ( */}

                                                  <Row>
                                                    <div className="border p-3 rounded shadow-sm my-3">
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            1.Are Labels
                                                            Returned When There
                                                            Is A Style Change
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="sewingLabelMou"
                                                            iconClassName="dropdownIcon"
                                                            name="sewingLabelMou"
                                                            code="sewingLabelMouCode"
                                                            description="sewingLabelMouDesc"
                                                            setValue={
                                                              item?.sewingLabelMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="sewingLabelRemarks"
                                                            value={
                                                              item.sewingLabelRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "sewingLabelRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.sewingLabelUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.sewingLabelUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            2.Are Single Size
                                                            Labels Distributed
                                                            At A Time?
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="sewingSingleTimeMou"
                                                            iconClassName="dropdownIcon"
                                                            name="sewingSingleTimeMou"
                                                            code="sewingSingleTimeMouCode"
                                                            description="sewingSingleTimeMouDesc"
                                                            setValue={
                                                              item?.sewingSingleTimeMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="sewingSingleTimeRemarks"
                                                            name="sewingSingleTimeRemarks"
                                                            value={
                                                              item.sewingSingleTimeRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "sewingSingleTimeRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.sewingSingleTimeUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.sewingSingleTimeUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                    </div>
                                                  </Row>

                                                  {/* )
                                                                                      )}  */}
                                                </div>
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>
                                        <div className="d-flex-column justify-content-center">
                                          <Row>
                                            <Col xs={12} md={5} lg={5}>
                                              {/* <h4 className="mt-5 font-bold text-lg">
                                                                                    Sewing Room
                                                                                  </h4> */}

                                              <h5 className="bg-table-status bg-table-warning-status mt-4">
                                                Inline Examination
                                              </h5>
                                            </Col>
                                            <Col xs={12}>
                                              <div className="accordion-body">
                                                <div className="d-flex-column justify-content-center">
                                                  <Row className="pt-4 d-none d-lg-flex ">
                                                    {/* <Col xs={12} md={2} lg={2}>
                                                                                          <p className="fs-6 fw-medium d-flex ms-4">
                                                                                            Are All The Panels Cut In The Factory
                                                                                          </p>
                                                                                        </Col> */}
                                                    <Col xs={12} md={4} lg={1}>
                                                      <p className="fs-6 fw-medium d-flex ms-4">
                                                        Questions
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex ms-4"></p>
                                                    </Col>

                                                    <Col xs={12} md={4} lg={4}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Remarks
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Upload Documents
                                                      </p>
                                                    </Col>
                                                  </Row>
                                                  {/* {item.getProjectCertifications.map(
                                                                                        (doc, itemIndex) => ( */}

                                                  <Row>
                                                    <div className="border p-3 rounded shadow-sm my-3">
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            1.Random Inspection
                                                            Of Sewing Standards
                                                            At Sewing Machines
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="sewingStandardMou"
                                                            iconClassName="dropdownIcon"
                                                            name="sewingStandardMou"
                                                            code="sewingStandardMouCode"
                                                            description="sewingStandardMouDesc"
                                                            setValue={
                                                              item?.sewingStandardMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="sewingStandardRemarks"
                                                            value={
                                                              item.sewingStandardRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "sewingStandardRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.sewingStandardUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.sewingStandardUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            2.Adequate
                                                            Checkpoint For Parts
                                                            Ready
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="sewingAdequateMou"
                                                            iconClassName="dropdownIcon"
                                                            name="sewingAdequateMou"
                                                            code="sewingAdequateMouCode"
                                                            description="sewingAdequateMouDesc"
                                                            setValue={
                                                              item?.sewingAdequateMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="sewingAdequateRemarks"
                                                            name="sewingAdequateRemarks"
                                                            value={
                                                              item.sewingAdequateRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "sewingAdequateRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.sewingAdequateUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.sewingAdequateUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            3. Do We Have An
                                                            Machine Maintenance
                                                            Record
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="sewingMachineMaintananceMou"
                                                            iconClassName="dropdownIcon"
                                                            name="sewingMachineMaintananceMou"
                                                            code="sewingMachineMaintananceMouCode"
                                                            description="sewingMachineMaintananceMouDesc"
                                                            setValue={
                                                              item?.sewingMachineMaintananceMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="sewingMachineMaintananceRemarks"
                                                            name="sewingMachineMaintananceRemarks"
                                                            value={
                                                              item.sewingMachineMaintananceRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "sewingMachineMaintananceRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.sewingMachineMaintananceUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.sewingMachineMaintananceUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            4. Inspection Of
                                                            Partially Sewn
                                                            Garments
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="sewnGarmentsMou"
                                                            iconClassName="dropdownIcon"
                                                            name="sewnGarmentsMou"
                                                            code="sewnGarmentsMouCode"
                                                            description="sewnGarmentsMouDesc"
                                                            setValue={
                                                              item?.sewnGarmentsMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="sewnGarmentsRemarks"
                                                            name="sewnGarmentsRemarks"
                                                            value={
                                                              item.sewnGarmentsRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "sewnGarmentsRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.sewnGarmentsUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.sewnGarmentsUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            5.Record Keeping And
                                                            Analysis Of Reports
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="sewnReportsMou"
                                                            iconClassName="dropdownIcon"
                                                            name="sewnReportsMou"
                                                            code="sewnReportsMouCode"
                                                            description="sewnReportsMouDesc"
                                                            setValue={
                                                              item?.sewnReportsMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="sewnReportsRemarks"
                                                            name="sewnReportsRemarks"
                                                            value={
                                                              item.sewnReportsRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "sewnReportsRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.sewnReportsUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.sewnReportsUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            6.Are Inspectors
                                                            Able To Retrieve
                                                            Approval Sample For
                                                            Reference?
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="sewnRefferenceMou"
                                                            iconClassName="dropdownIcon"
                                                            name="sewnRefferenceMou"
                                                            code="sewnRefferenceMouCode"
                                                            description="sewnRefferenceMouDesc"
                                                            setValue={
                                                              item?.sewnRefferenceMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="sewnRefferenceRemarks"
                                                            name="sewnRefferenceRemarks"
                                                            value={
                                                              item.sewnRefferenceRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "sewnRefferenceRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.sewnRefferenceUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.sewnRefferenceUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            7.Standards Checking
                                                            Available At
                                                            Inspection
                                                            Workstations
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="workStationsMou"
                                                            iconClassName="dropdownIcon"
                                                            name="workStationsMou"
                                                            code="workStationsMouCode"
                                                            description="workStationsMouDesc"
                                                            setValue={
                                                              item?.workStationsMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="workStationsRemarks"
                                                            name="workStationsRemarks"
                                                            value={
                                                              item.workStationsRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "workStationsRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.workStationsUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.workStationsUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            7.Clear Separation
                                                            Of Gmts Not
                                                            Inspected/ Inspected
                                                            / Faulty Gmt
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="gmtsMou"
                                                            iconClassName="dropdownIcon"
                                                            name="gmtsMou"
                                                            code="gmtsMouCode"
                                                            description="gmtsMouDesc"
                                                            setValue={
                                                              item?.gmtsMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="gmtsRemarks"
                                                            name="gmtsRemarks"
                                                            value={
                                                              item.gmtsRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "gmtsRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.gmtsUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.gmtsUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                    </div>
                                                  </Row>

                                                  {/* )
                                                                                      )}  */}
                                                </div>
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>
                                        <div className="d-flex-column justify-content-center">
                                          <Row>
                                            <Col xs={12} md={5} lg={5}>
                                              {/* <h4 className="mt-5 font-bold text-lg">
                                                                                    Sewing Room
                                                                                  </h4> */}

                                              <h5 className="bg-table-status bg-table-warning-status mt-4">
                                                Inspection At End Of Line
                                              </h5>
                                            </Col>
                                            <Col xs={12}>
                                              <div className="accordion-body">
                                                <div className="d-flex-column justify-content-center">
                                                  <Row className="pt-4 d-none d-lg-flex ">
                                                    {/* <Col xs={12} md={2} lg={2}>
                                                                                          <p className="fs-6 fw-medium d-flex ms-4">
                                                                                            Are All The Panels Cut In The Factory
                                                                                          </p>
                                                                                        </Col> */}
                                                    <Col xs={12} md={4} lg={1}>
                                                      <p className="fs-6 fw-medium d-flex ms-4">
                                                        Questions
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex ms-4"></p>
                                                    </Col>

                                                    <Col xs={12} md={4} lg={4}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Remarks
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Upload Documents
                                                      </p>
                                                    </Col>
                                                  </Row>
                                                  {/* {item.getProjectCertifications.map(
                                                                                        (doc, itemIndex) => ( */}

                                                  <Row>
                                                    <div className="border p-3 rounded shadow-sm my-3">
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            1.100% End Line
                                                            Checking Process
                                                            Done
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="processDoneMou"
                                                            iconClassName="dropdownIcon"
                                                            name="processDoneMou"
                                                            code="processDoneMouCode"
                                                            description="processDoneMouDesc"
                                                            setValue={
                                                              item?.processDoneMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="processDoneRemarks"
                                                            value={
                                                              item.processDoneRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "processDoneRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.processDoneUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.processDoneUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            2.Clear Separation
                                                            Of Gmts Not
                                                            Inspected /
                                                            Inspected / Faulty
                                                            Gmt
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="seperationMou"
                                                            iconClassName="dropdownIcon"
                                                            name="seperationMou"
                                                            code="seperationMouCode"
                                                            description="seperationMouDesc"
                                                            setValue={
                                                              item?.seperationMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="seperationRemarks"
                                                            name="seperationRemarks"
                                                            value={
                                                              item.seperationRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "seperationRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.seperationUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.seperationUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            3. Are Inspectors
                                                            Trimmng The Garment
                                                            During Inspection?
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="garmentsInspectionMou"
                                                            iconClassName="dropdownIcon"
                                                            name="garmentsInspectionMou"
                                                            code="garmentsInspectionMouCode"
                                                            description="garmentsInspectionMouDesc"
                                                            setValue={
                                                              item?.garmentsInspectionMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="garmentsInspectionRemarks"
                                                            name="garmentsInspectionRemarks"
                                                            value={
                                                              item.garmentsInspectionRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "garmentsInspectionRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.garmentsInspectionUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.garmentsInspectionUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            4.Before Wash
                                                            Measurement Critical
                                                            (Pom) On All Sizes
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="washMeasurementsMou"
                                                            iconClassName="dropdownIcon"
                                                            name="washMeasurementsMou"
                                                            code="washMeasurementsMouCode"
                                                            description="washMeasurementsMouDesc"
                                                            setValue={
                                                              item?.washMeasurementsMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="washMeasurementsRemarks"
                                                            name="washMeasurementsRemarks"
                                                            value={
                                                              item.washMeasurementsRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "washMeasurementsRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.washMeasurementsUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.washMeasurementsUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            5.Record Keeping And
                                                            Analysis Of Reports
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="analisysReportsMou"
                                                            iconClassName="dropdownIcon"
                                                            name="analisysReportsMou"
                                                            code="analisysReportsMouCode"
                                                            description="analisysReportsMouDesc"
                                                            setValue={
                                                              item?.analisysReportsMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="analisysReportsRemarks"
                                                            name="analisysReportsRemarks"
                                                            value={
                                                              item.analisysReportsRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "analisysReportsRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.analisysReportsUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.analisysReportsUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                    </div>
                                                  </Row>

                                                  {/* )
                                                                                      )}  */}
                                                </div>
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>
                                        <div className="d-flex-column justify-content-center">
                                          <Row>
                                            <Col xs={12} md={5} lg={5}>
                                              {/* <h4 className="mt-5 font-bold text-lg">
                                                                                    Sewing Room
                                                                                  </h4> */}

                                              <h5 className="bg-table-status bg-table-warning-status mt-4">
                                                NEEDLE/METAL CONTAMINANTS
                                                CONTROL
                                              </h5>
                                            </Col>
                                            <Col xs={12}>
                                              <div className="accordion-body">
                                                <div className="d-flex-column justify-content-center">
                                                  <Row className="pt-4 d-none d-lg-flex ">
                                                    {/* <Col xs={12} md={2} lg={2}>
                                                                                          <p className="fs-6 fw-medium d-flex ms-4">
                                                                                            Are All The Panels Cut In The Factory
                                                                                          </p>
                                                                                        </Col> */}
                                                    <Col xs={12} md={4} lg={1}>
                                                      <p className="fs-6 fw-medium d-flex ms-4">
                                                        Questions
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex ms-4"></p>
                                                    </Col>

                                                    <Col xs={12} md={4} lg={4}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Remarks
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Upload Documents
                                                      </p>
                                                    </Col>
                                                  </Row>
                                                  {/* {item.getProjectCertifications.map(
                                                                                        (doc, itemIndex) => ( */}

                                                  <Row>
                                                    <div className="border p-3 rounded shadow-sm my-3">
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            1.Are Needles
                                                            Exchanged On A 1 For
                                                            1 Basis
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="exchnageMou"
                                                            iconClassName="dropdownIcon"
                                                            name="exchnageMou"
                                                            code="exchnageMouCode"
                                                            description="exchnageMouDesc"
                                                            setValue={
                                                              item?.exchnageMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="exchnageRemarks"
                                                            value={
                                                              item.exchnageRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "exchnageRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.exchnageUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.exchnageUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            2.Tape All Broken
                                                            Needle And Record
                                                            Keeping
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="recordKeepingMou"
                                                            iconClassName="dropdownIcon"
                                                            name="recordKeepingMou"
                                                            code="recordKeepingMouCode"
                                                            description="recordKeepingMouDesc"
                                                            setValue={
                                                              item?.recordKeepingMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="recordKeepingRemarks"
                                                            name="recordKeepingRemarks"
                                                            value={
                                                              item.recordKeepingRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "recordKeepingRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.recordKeepingUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.recordKeepingUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            3. Are Hand Sewing
                                                            Needles Controlled
                                                            With Daily Records
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="dailyRecordsMou"
                                                            iconClassName="dropdownIcon"
                                                            name="dailyRecordsMou"
                                                            code="dailyRecordsMouCode"
                                                            description="dailyRecordsMouDesc"
                                                            setValue={
                                                              item?.dailyRecordsMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="dailyRecordsRemarks"
                                                            name="dailyRecordsRemarks"
                                                            value={
                                                              item.dailyRecordsRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "dailyRecordsRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.dailyRecordsUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.dailyRecordsUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            4.Are Hand Tools
                                                            Tied To Machine And
                                                            Controlled
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="handToolsMou"
                                                            iconClassName="dropdownIcon"
                                                            name="handToolsMou"
                                                            code="handToolsMouCode"
                                                            description="handToolsMouDesc"
                                                            setValue={
                                                              item?.handToolsMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="handToolsRemarks"
                                                            name="handToolsRemarks"
                                                            value={
                                                              item.handToolsRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "handToolsRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.handToolsUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.handToolsUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                    </div>
                                                  </Row>

                                                  {/* )
                                                                                      )}  */}
                                                </div>
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>
                                        <div className="d-flex-column justify-content-center">
                                          <Row>
                                            <Col xs={12} md={5} lg={5}>
                                              {/* <h4 className="mt-5 font-bold text-lg">
                                                                                    Sewing Room
                                                                                  </h4> */}
                                              <h4 className="mt-5 font-bold text-lg">
                                                Packing
                                              </h4>

                                              <h5 className="bg-table-status bg-table-warning-status mt-4">
                                                Packing
                                              </h5>
                                            </Col>
                                            <Col xs={12}>
                                              <div className="accordion-body">
                                                <div className="d-flex-column justify-content-center">
                                                  <Row className="pt-4 d-none d-lg-flex ">
                                                    {/* <Col xs={12} md={2} lg={2}>
                                                                                          <p className="fs-6 fw-medium d-flex ms-4">
                                                                                            Are All The Panels Cut In The Factory
                                                                                          </p>
                                                                                        </Col> */}
                                                    <Col xs={12} md={4} lg={1}>
                                                      <p className="fs-6 fw-medium d-flex ms-4">
                                                        Questions
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex ms-4"></p>
                                                    </Col>

                                                    <Col xs={12} md={4} lg={4}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Remarks
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Upload Documents
                                                      </p>
                                                    </Col>
                                                  </Row>
                                                  {/* {item.getProjectCertifications.map(
                                                                                        (doc, itemIndex) => ( */}

                                                  <Row>
                                                    <div className="border p-3 rounded shadow-sm my-3">
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            1.Is There A Clear
                                                            Separation Of
                                                            Size/Color Of
                                                            Packaging Material
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="packingSeperationMou"
                                                            iconClassName="dropdownIcon"
                                                            name="packingSeperationMou"
                                                            code="packingSeperationMouCode"
                                                            description="packingSeperationMouDesc"
                                                            setValue={
                                                              item?.packingSeperationMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="packingSeperationRemarks"
                                                            value={
                                                              item.packingSeperationRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "packingSeperationRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.packingSeperationUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.packingSeperationUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            2.Is There A
                                                            Standard Sample To
                                                            Show The Packing
                                                            Method
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="packingMethodMou"
                                                            iconClassName="dropdownIcon"
                                                            name="packingMethodMou"
                                                            code="packingMethodMouCode"
                                                            description="packingMethodMouDesc"
                                                            setValue={
                                                              item?.packingMethodMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="packingMethodRemarks"
                                                            name="packingMethodRemarks"
                                                            value={
                                                              item.packingMethodRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "packingMethodRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.packingMethodUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.packingMethodUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            3. Before Packing
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="beforePackingMou"
                                                            iconClassName="dropdownIcon"
                                                            name="beforePackingMou"
                                                            code="beforePackingMouCode"
                                                            description="beforePackingMouDesc"
                                                            setValue={
                                                              item?.beforePackingMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="beforePackingRemarks"
                                                            name="beforePackingRemarks"
                                                            value={
                                                              item.beforePackingRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "beforePackingRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.beforePackingUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.beforePackingUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                    </div>
                                                  </Row>

                                                  {/* )
                                                                                      )}  */}
                                                </div>
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>
                                        <div className="d-flex-column justify-content-center">
                                          <Row>
                                            <Col xs={12} md={5} lg={5}>
                                              {/* <h4 className="mt-5 font-bold text-lg">
                                                                                    Sewing Room
                                                                                  </h4> */}
                                              <h4 className="mt-5 font-bold text-lg">
                                                Quality Inspection
                                              </h4>

                                              <h5 className="bg-table-status bg-table-warning-status mt-4">
                                                Inhouse QA
                                              </h5>
                                            </Col>
                                            <Col xs={12}>
                                              <div className="accordion-body">
                                                <div className="d-flex-column justify-content-center">
                                                  <Row className="pt-4 d-none d-lg-flex ">
                                                    {/* <Col xs={12} md={2} lg={2}>
                                                                                          <p className="fs-6 fw-medium d-flex ms-4">
                                                                                            Are All The Panels Cut In The Factory
                                                                                          </p>
                                                                                        </Col> */}
                                                    <Col xs={12} md={4} lg={1}>
                                                      <p className="fs-6 fw-medium d-flex ms-4">
                                                        Questions
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex ms-4"></p>
                                                    </Col>

                                                    <Col xs={12} md={4} lg={4}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Remarks
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Upload Documents
                                                      </p>
                                                    </Col>
                                                  </Row>
                                                  {/* {item.getProjectCertifications.map(
                                                                                        (doc, itemIndex) => ( */}

                                                  <Row>
                                                    <div className="border p-3 rounded shadow-sm my-3">
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            1.Name Of Quality
                                                            Manager:
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="qualityManagerMou"
                                                            iconClassName="dropdownIcon"
                                                            name="qualityManagerMou"
                                                            code="qualityManagerMouCode"
                                                            description="qualityManagerMouDesc"
                                                            setValue={
                                                              item?.qualityManagerMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="qualityManagerRemarks"
                                                            value={
                                                              item.qualityManagerRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "qualityManagerRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.qualityManagerUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.qualityManagerUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            2.Does The Factory
                                                            Have An Independent
                                                            Quality Team?
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="qualityTeamMou"
                                                            iconClassName="dropdownIcon"
                                                            name="qualityTeamMou"
                                                            code="qualityTeamMouCode"
                                                            description="qualityTeamMouDesc"
                                                            setValue={
                                                              item?.qualityTeamMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="qualityTeamRemarks"
                                                            name="qualityTeamRemarks"
                                                            value={
                                                              item.qualityTeamRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "qualityTeamRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.qualityTeamUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.qualityTeamUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            3. Number Of Persons
                                                            In The Team Is
                                                            Adequate?
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="personsMou"
                                                            iconClassName="dropdownIcon"
                                                            name="personsMou"
                                                            code="personsMouCode"
                                                            description="personsMouDesc"
                                                            setValue={
                                                              item?.personsMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="personsRemarks"
                                                            name="personsRemarks"
                                                            value={
                                                              item.personsRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "personsRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.personsUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.personsUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            4.Does The Nqa /Qam
                                                            Have Adequate
                                                            Knowledge Of Audit
                                                            Process
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="auditProcessMou"
                                                            iconClassName="dropdownIcon"
                                                            name="auditProcessMou"
                                                            code="auditProcessMouCode"
                                                            description="auditProcessMouDesc"
                                                            setValue={
                                                              item?.auditProcessMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="auditProcessRemarks"
                                                            name="auditProcessRemarks"
                                                            value={
                                                              item.auditProcessRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "auditProcessRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.auditProcessUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.auditProcessUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            5. Carton Audit Done
                                                            By Nqa
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="nqaMou"
                                                            iconClassName="dropdownIcon"
                                                            name="nqaMou"
                                                            code="nqaMouCode"
                                                            description="nqaMouDesc"
                                                            setValue={
                                                              item?.nqaMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="nqaRemarks"
                                                            name="nqaRemarks"
                                                            value={
                                                              item.nqaRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "nqaRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.nqaUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.nqaUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                    </div>
                                                  </Row>

                                                  {/* )
                                                                                      )}  */}
                                                </div>
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>
                                        <div className="d-flex-column justify-content-center">
                                          <Row>
                                            <Col xs={12} md={5} lg={5}>
                                              <h5 className="bg-table-status bg-table-warning-status mt-4">
                                                MANDATORY QUALIFICATION
                                              </h5>
                                            </Col>
                                            <Col xs={12}>
                                              <div className="accordion-body">
                                                <div className="d-flex-column justify-content-center">
                                                  <Row className="pt-4 d-none d-lg-flex ">
                                                    {/* <Col xs={12} md={2} lg={2}>
                                                                                          <p className="fs-6 fw-medium d-flex ms-4">
                                                                                            Are All The Panels Cut In The Factory
                                                                                          </p>
                                                                                        </Col> */}
                                                    <Col xs={12} md={4} lg={1}>
                                                      <p className="fs-6 fw-medium d-flex ms-4">
                                                        Questions
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex ms-4"></p>
                                                    </Col>

                                                    <Col xs={12} md={4} lg={4}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Remarks
                                                      </p>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                      <p className="fs-6 fw-medium d-flex">
                                                        Upload Documents
                                                      </p>
                                                    </Col>
                                                  </Row>
                                                  {/* {item.getProjectCertifications.map(
                                                                                        (doc, itemIndex) => ( */}

                                                  <Row>
                                                    <div className="border p-3 rounded shadow-sm my-3">
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            1.Is There A Quality
                                                            Manager Or Nqa In
                                                            The Factory?
                                                          </strong>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="qualityNqaMou"
                                                            iconClassName="dropdownIcon"
                                                            name="qualityNqaMou"
                                                            code="qualityNqaMouCode"
                                                            description="qualityNqaMouDesc"
                                                            setValue={
                                                              item?.qualityNqaMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Remarks"
                                                            name="qualityNqaRemarks"
                                                            value={
                                                              item.qualityNqaRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "qualityNqaRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                            // required={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.qualityManagerUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.qualityManagerUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            2.Is The Factory
                                                            Capable Of Making
                                                            Product As Mentioned
                                                            With Equipment Amd
                                                            Skill Set
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="skillSetMou"
                                                            iconClassName="dropdownIcon"
                                                            name="skillSetMou"
                                                            code="skillSetMouCode"
                                                            description="skillSetMouDesc"
                                                            setValue={
                                                              item?.skillSetMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="skillSetRemarks"
                                                            name="skillSetRemarks"
                                                            value={
                                                              item.skillSetRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "skillSetRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.skillSetUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.skillSetUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            3. Is There A Light
                                                            Box To Check Shades
                                                            And Panles In The
                                                            Location
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="panelsLocationsMou"
                                                            iconClassName="dropdownIcon"
                                                            name="panelsLocationsMou"
                                                            code="panelsLocationsMouCode"
                                                            description="panelsLocationsMouDesc"
                                                            setValue={
                                                              item?.panelsLocationsMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="panelsLocationsRemarks"
                                                            name="panelsLocationsRemarks"
                                                            value={
                                                              item.panelsLocationsRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "panelsLocationsRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.panelsLocationsUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.panelsLocationsUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            4.Measurement Check
                                                            Of Critical Pom 100%
                                                            -Prior Packing
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="priorPackingMou"
                                                            iconClassName="dropdownIcon"
                                                            name="priorPackingMou"
                                                            code="priorPackingMouCode"
                                                            description="priorPackingMouDesc"
                                                            setValue={
                                                              item?.priorPackingMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="priorPackingRemarks"
                                                            name="priorPackingRemarks"
                                                            value={
                                                              item.priorPackingRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "priorPackingRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.priorPackingUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.priorPackingUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                      <Row className="align-items-center">
                                                        <Col xs={12} md={2}>
                                                          <strong>
                                                            5. Rejection Record
                                                            Of Garments In
                                                            Finishing / Final
                                                            Closure Of Po
                                                          </strong>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={2}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <ComboboxField
                                                            placeholder="Mou"
                                                            // data={dropdownOption2}
                                                            id="recordRejectionMou"
                                                            iconClassName="dropdownIcon"
                                                            name="recordRejectionMou"
                                                            code="recordRejectionMouCode"
                                                            description="recordRejectionMouDesc"
                                                            setValue={
                                                              item?.recordRejectionMou
                                                            }
                                                            getvalue={
                                                              setDropdownData
                                                            }
                                                            index={index}
                                                            onChangeValue={(
                                                              index,
                                                              fieldName,
                                                              value
                                                            ) =>
                                                              handleProjectInputChange(
                                                                value,
                                                                index,
                                                                fieldName
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={3}
                                                          lg={3}
                                                          className="commTopButtonRightLeftPadding"
                                                        >
                                                          <TextAreaField
                                                            className="inputBox"
                                                            placeholder="Reamrks"
                                                            id="recordRejectionRemarks"
                                                            name="recordRejectionRemarks"
                                                            value={
                                                              item.recordRejectionRemarks ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleProjectInputChange(
                                                                e.target.value,
                                                                index,
                                                                "recordRejectionRemarks"
                                                              )
                                                            }
                                                            disabled={true}
                                                          />
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={1}
                                                          lg={1}
                                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                        >
                                                          {(item?.recordRejectionUploads && (
                                                            <img
                                                              src="assets/img/newIcons/attached-file.png"
                                                              className="mt-1 attachmentIcon"
                                                              alt="attachments"
                                                              onClick={() =>
                                                                handleViewFile(
                                                                  item?.recordRejectionUploads
                                                                )
                                                              }
                                                            />
                                                          )) ||
                                                            "--"}
                                                        </Col>
                                                      </Row>
                                                    </div>
                                                  </Row>

                                                  {/* )
                                                                                      )}  */}
                                                </div>
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>

                                  <Row>
                                    <Col
                                      xs={12}
                                      md={12}
                                      lg={12}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <div></div>
                                    </Col>
                                  </Row>

                                  <hr />
                                </div>
                              ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </>
            )}

            {/* customer Doucment Type isCardVisible2 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">DT</span>
                    </Col>
                    <Col xs={4} md={9} lg={9}>
                      <span className="headerTitle"> Doucment Type</span>
                      <span className="subHeaderTitle">Doucment Type</span>
                    </Col>
                    {/* <Col xs={4} md={2} lg={2}>
                                    <div className="d-flex justify-content-end  p-2 me-3">
                                      <button className="btnTable" onClick={addDocumentType}>
                                        <i className="bi bi-plus-lg"></i> Add
                                      </button>
                                    </div>
                                  </Col> */}
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <div className="d-flex-column justify-content-center">
                            <Row>
                              <Col xs={12}>
                                <div className="accordion-body">
                                  <div className="d-flex-column justify-content-center">
                                    <Row className="pt-4 d-none d-lg-flex ">
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Document Type
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Document Number
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Issue Date
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={1}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          View Files
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Attachments
                                        </p>
                                      </Col>
                                      {/* <Col xs={12} md={4} lg={2}>
                                                      <p className="fs-6 fw-medium d-flex justify-content-center ms-4">
                                                        Action
                                                      </p>
                                                    </Col> */}
                                    </Row>
                                    {getDocumentTypeData.length > 0 &&
                                      getDocumentTypeData?.map((doc, index) => (
                                        <Row key={doc.id}>
                                          <Col xs={12}>
                                            <hr className="mx-4 my-0 text-color-black" />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <ComboboxField
                                              label=""
                                              placeholder="Document type"
                                              data={getdocumentType}
                                              id="documentType"
                                              iconClassName="dropdownIcon"
                                              name="documentType"
                                              code="documentTypeCode"
                                              description="documentTypeDesc"
                                              setValue={doc?.documentType}
                                              getvalue={setDropdownData}
                                              index={doc.id}
                                              onChangeValue={handleInputChange}
                                              disabled={getDisabledStatus}
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox"
                                              placeholder="Document Number"
                                              value={doc.documentNumber}
                                              onChange={(e) =>
                                                handleInputChange(
                                                  doc.id,
                                                  "documentNumber",
                                                  e.target.value
                                                )
                                              }
                                              disabled={getDisabledStatus}
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox"
                                              type="date"
                                              value={doc.issueDate}
                                              onChange={(e) =>
                                                handleInputChange(
                                                  doc.id,
                                                  "issueDate",
                                                  e.target.value
                                                )
                                              }
                                              disabled={getDisabledStatus}
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={1}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <div className="d-flex justify-content-center">
                                              {(doc.iSOCertification && (
                                                <img
                                                  src="assets/img/newIcons/attached-file.png"
                                                  className="mt-1 attachmentIcon"
                                                  alt="attachments"
                                                  onClick={() =>
                                                    handleViewFile(
                                                      doc.iSOCertification
                                                    )
                                                  }
                                                />
                                              )) ||
                                                "--"}
                                            </div>
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={3}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <FileUploadComponent
                                              id={doc.id}
                                              name="iSOCertification"
                                              label=""
                                              allowedTypes={[
                                                "image/png",
                                                "image/jpeg",
                                                "application/pdf",
                                              ]}
                                              multiple={true} // Change to `false` for single file selection
                                              required={true}
                                              onSuccessUpload={
                                                onSuccessUploadDocumentType
                                              }
                                              value={doc.iSOCertification || ""}
                                              disabled={getDisabledStatus}
                                            />
                                          </Col>
                                          {/* <Col
                                                        xs={12}
                                                        md={4}
                                                        lg={1}
                                                        className="commTopButtonRightLeftPadding"
                                                      >
                                                        <i
                                                          onClick={() =>
                                                            deleteDocumentType(doc.id)
                                                          }
                                                          className="bi bi-trash text-danger fs-4"
                                                        />
                                                      </Col> */}
                                        </Row>
                                      ))}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* 08 Banker Info*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible8
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility8}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">BK</span>
                    </Col>
                    <Col xs={12} md={8} lg={8}>
                      <span className="headerTitle">Bank Information</span>
                      <span className="subHeaderTitle">
                        Bank Information (Please add all your Bank Accounts)
                      </span>
                    </Col>
                    {/* <Col xs={4} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        onClick={() => addBankForm()}
                        disabled={getDisabledStatus}
                      >
                        <i className="bi bi-plus-lg"></i> Add Bank Info
                      </button>
                    </Col> */}

                    <Col xs={2} md={1} lg={1} className="">
                      <CommonFillter />
                    </Col>
                  </Row>
                </h2>

                {/* Banker Information */}
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible8 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    {/* To Load Dynamic Bank Info Form */}
                    {getBankDetails &&
                      getBankDetails?.map((item, index) => (
                        <div key={index}>
                          <Row className="pt-2 pb-2">
                            <Col
                              xs={12}
                              md={12}
                              lg={12}
                              className="commTopButtonRightLeftPadding"
                            >
                              <h6>Bank Information Section {index + 1}</h6>
                              {/* <span
                                className="deleteIconAccordion"
                                onClick={() => removeBankForm(index)}
                              >
                                {" "}
                                <i className="bi bi-x-circle"></i>{" "}
                              </span> */}
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Is the Company bank included on list?"
                                placeholder=""
                                data={dropdownOption}
                                id="bankNotListed"
                                iconClassName="dropdownIcon"
                                name="bankNotListed"
                                setValue={item?.bankNotListed || ""}
                                getvalue={setDropdownData}
                                index={index}
                                // onChangeValue={handleChangeBankInfo}
                                disabled={getDisabledStatus}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="BankID"
                                placeholder=""
                                data={getBankDetailsData}
                                id="bankKey"
                                iconClassName="dropdownIcon"
                                name="bankKey"
                                setValue={item?.bankKey}
                                getvalue={setDropdownData}
                                index={index}
                                // onChangeValue={handleChangeBankInfo}
                                disabled={getDisabledStatus}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Bank A/C Number"
                                name="bankAccountNumber"
                                placeholder=""
                                value={item?.bankAccountNumber}
                                // onChange={(e) =>
                                //   handleChangeBankInfo(
                                //     index,
                                //     "bankAccountNumber",
                                //     e.target.value
                                //   )
                                // }
                                disabled={getDisabledStatus}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Bank Name"
                                name="bankBranchName"
                                placeholder=""
                                value={item?.bankBranchName}
                                // onChange={(e) =>
                                //   handleChangeBankInfo(
                                //     index,
                                //     "bankBranchName",
                                //     e.target.value
                                //   )
                                // }
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              {/* <ComboboxField
                                label="Bank Country"
                                placeholder=""
                                data={dropdownOption}
                                id="bankCountry"
                                iconClassName="dropdownIcon"
                                name="bankCountry"
                                setValue={item?.bankCountry || ""}
                                getvalue={setDropdownData}
                                index={index}
                                onChangeValue={handleChangeBankInfo}
                                disabled={getDisabledStatus}
                              /> */}
                              <InputField
                                className="inputBox"
                                label="Bank Country"
                                name="bankCountryDescription"
                                placeholder=""
                                value={item?.bankCountryDescription}
                                // onChange={(e) =>
                                //   handleChangeBankInfo(
                                //     index,
                                //     "bankCountryDescription",
                                //     e.target.value
                                //   )
                                // }
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              {/* <ComboboxField
                                label="Branch Address"
                                placeholder=""
                                data={dropdownOption}
                                id="bankAddress"
                                iconClassName="dropdownIcon"
                                name="bankAddress"
                                setValue={item?.bankAddress || ""}
                                getvalue={setDropdownData}
                                index={index}
                                onChangeValue={handleChangeBankInfo}
                                disabled={getDisabledStatus}
                              /> */}
                              <InputField
                                className="inputBox"
                                label="Branch Address"
                                name="bankAddress"
                                placeholder=""
                                value={item?.bankAddress}
                                // onChange={(e) =>
                                //   handleChangeBankInfo(
                                //     index,
                                //     "bankAddress",
                                //     e.target.value
                                //   )
                                // }
                                disabled={true}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              {/* <ComboboxField
                                label="Preferred Currency"
                                placeholder=""
                                data={dropdownOption}
                                id="preferredCurrency"
                                iconClassName="dropdownIcon"
                                name="preferredCurrency"
                                setValue={item?.preferredCurrency || ""}
                                getvalue={setDropdownData}
                                index={index}
                                onChangeValue={handleChangeBankInfo}
                                disabled={getDisabledStatus}
                              /> */}
                              <InputField
                                className="inputBox"
                                label="Preferred Currency"
                                name="bankCurrency"
                                placeholder=""
                                value={item?.bankCurrency}
                                // onChange={(e) =>
                                //   handleChangeBankInfo(
                                //     index,
                                //     "bankCurrency",
                                //     e.target.value
                                //   )
                                // }
                                disabled={true}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="IBAN"
                                name="iban"
                                placeholder=""
                                value={item?.iban}
                                // onChange={(e) =>
                                //   handleChangeBankInfo(
                                //     index,
                                //     "iban",
                                //     e.target.value
                                //   )
                                // }
                                disabled={getDisabledStatus}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Name of Beneficiary"
                                extraLabel="Name of Beneficiary (Bank Account Holder Name) as per company /trade license"
                                name="AccountHolderName"
                                placeholder=""
                                value={item?.AccountHolderName}
                                // onChange={(e) =>
                                //   handleChangeBankInfo(
                                //     index,
                                //     "AccountHolderName",
                                //     e.target.value
                                //   )
                                // }
                                disabled={getDisabledStatus}
                              />
                              {/* <ComboboxField
                                label="Name of Beneficiary"
                                placeholder=""
                                extraLabel="Name of Beneficiary (Bank Account Holder Name) as per company /trade license"
                                data={dropdownOption}
                                id="AccountHolderName"
                                iconClassName="dropdownIcon"
                                name="AccountHolderName"
                                setValue={item?.AccountHolderName || ""}
                                getvalue={setDropdownData}
                                index={index}
                                onChangeValue={handleChangeBankInfo}
                                disabled={getDisabledStatus}
                              /> */}
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Swift IFSC Code"
                                placeholder=""
                                data={dropdownOption}
                                id="swiftIfscCode"
                                iconClassName="dropdownIcon"
                                name="swiftIfscCode"
                                setValue={item?.swiftIfscCode || ""}
                                getvalue={setDropdownData}
                                index={index}
                                // onChangeValue={handleChangeBankInfo}
                                disabled={getDisabledStatus}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding  justify-content-center align-items-center"
                            >
                              <div className="d-flex flex-column ">
                                <p className="fw-medium m-0 text-nowrap">
                                  BankCompany Letterhead
                                </p>

                                {(item?.bankCompanyletterhead && (
                                  <img
                                    src="assets/img/newIcons/attached-file.png"
                                    className="mt-1 attachmentIcon"
                                    alt="attachments"
                                    onClick={() =>
                                      handleViewFile(
                                        item?.bankCompanyletterhead
                                      )
                                    }
                                  />
                                )) ||
                                  "--"}
                              </div>
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding  justify-content-center align-items-center"
                            >
                              <div className="d-flex flex-column ">
                                <p className="fw-medium m-0 text-nowrap">
                                  Confirmation Letter
                                </p>

                                {(item?.bankConfirmationLetter && (
                                  <img
                                    src="assets/img/newIcons/attached-file.png"
                                    className="mt-1 attachmentIcon"
                                    alt="attachments"
                                    onClick={() =>
                                      handleViewFile(
                                        item?.bankConfirmationLetter
                                      )
                                    }
                                  />
                                )) ||
                                  "--"}
                              </div>
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding  justify-content-center align-items-center"
                            >
                              <div className="d-flex flex-column ">
                                <p className="fw-medium m-0 text-nowrap">
                                  Correspondence Bank Details
                                </p>

                                {(item?.chipsCode && (
                                  <img
                                    src="assets/img/newIcons/attached-file.png"
                                    className="mt-1 attachmentIcon"
                                    alt="attachments"
                                    onClick={() =>
                                      handleViewFile(item?.chipsCode)
                                    }
                                  />
                                )) ||
                                  "--"}
                              </div>
                            </Col>

                            <Col
                              xs={12}
                              md={12}
                              lg={12}
                              className="commTopButtonRightLeftPadding"
                            >
                              <hr />
                            </Col>
                          </Row>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>

            {(formInputs.status === "In Registration" ||
              formInputs.status === "Registered") && (
              <>
                {formInputs.qms === "Yes" && (
                  <>
                    {formInputs.qms === "Yes" && (
                      <>
                        <div className="accordion mb-4" id="accordionExample">
                          <div className="accordion-item">
                            <h2 className="accordion-header">
                              <Row className="accordion-button">
                                <Col
                                  xs={1}
                                  md={1}
                                  lg={1}
                                  className="text-left arrowBtn"
                                >
                                  <i
                                    className={`bi ${
                                      isCardVisible3
                                        ? "bi-chevron-right"
                                        : "bi-chevron-down"
                                    }`}
                                    onClick={toggleCardVisibility3}
                                  ></i>
                                </Col>
                                <Col
                                  xs={1}
                                  md={1}
                                  lg={1}
                                  className="text-center logoBtn"
                                >
                                  <span className="iconLogo">VU</span>
                                </Col>
                                <Col xs={8} md={9} lg={9}>
                                  <span className="headerTitle">
                                    Venodr Code and MOU Updation
                                  </span>
                                  <span className="subHeaderTitle">
                                    The Venodr Code and Signed MOU Can be
                                    Updated for all Incactive New Vendors from
                                    Compilance DataBase Post Compilance Approval
                                  </span>
                                </Col>
                              </Row>
                            </h2>

                            <div
                              className={`accordion-collapse collapse show ${
                                isCardVisible3 ? "visible" : ""
                              }`}
                            >
                              <div className="accordion-body">
                                <Row className="pt-2 pb-4">
                                  {/* <Col
                                                xs={12}
                                                md={4}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding"
                                              >
                                                <InputField
                                                  className="inputBox"
                                                  label="Vendor Code"
                                                  name="vendorCode"
                                                  placeholder=""
                                                  value={formInputs.vendorCode || ""}
                                                  onChange={onInputChange}
                                                  disabled={false}
                                                  // error={validation.vendorCode}
                                                  required={true}
                                                />
              
                                              </Col> */}
                                  {formInputs.qms === "Yes" && (
                                    <Col
                                      xs={12}
                                      md={4}
                                      lg={4}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Vendor Code"
                                        name="vendorCode"
                                        placeholder=""
                                        value={formInputs.userId || ""}
                                        onChange={onInputChange}
                                        disabled={true}
                                        required={true}
                                      />
                                    </Col>
                                  )}

                                  <Col
                                    xs={12}
                                    md={4}
                                    lg={4}
                                    className="commTopButtonRightLeftPadding"
                                  >
                                    <ComboboxField
                                      label="MOU"
                                      name="mou"
                                      // data={dropdownOption}
                                      id="mou"
                                      iconClassName="dropdownIcon"
                                      onChange={setDropdownData}
                                      setValue={formInputs.mou}
                                      getvalue={setDropdownData}
                                      disabled={true}
                                    />
                                  </Col>

                                  <Col
                                    xs={12}
                                    md={1}
                                    lg={1}
                                    className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                  >
                                    {(formInputs?.mouAttachment && (
                                      <img
                                        src="assets/img/newIcons/attached-file.png"
                                        className="mt-1 attachmentIcon"
                                        alt="attachments"
                                        onClick={() =>
                                          handleViewFile(
                                            formInputs?.mouAttachment
                                          )
                                        }
                                      />
                                    )) ||
                                      "--"}
                                  </Col>
                                  <Col
                                    xs={12}
                                    md={4}
                                    lg={4}
                                    className="commTopButtonRightLeftPadding"
                                  >
                                    <InputField
                                      className="inputBox"
                                      label="MOU Date"
                                      name="mouDate"
                                      type="date"
                                      min={2023}
                                      placeholder=""
                                      value={formInputs.mouDate || ""}
                                      onChange={onInputChange}
                                      disabled={true}
                                      // error={validation.mouDate}
                                      required={true}
                                    />
                                  </Col>
                                  <Col
                                    xs={12}
                                    md={4}
                                    lg={4}
                                    className="commTopButtonRightLeftPadding"
                                  >
                                    <InputField
                                      className="inputBox"
                                      label="Description"
                                      name="descriptionMou"
                                      placeholder=""
                                      value={formInputs.descriptionMou || ""}
                                      onChange={onInputChange}
                                      disabled={true}
                                      // error={validation.descriptionMou}
                                      required={true}
                                    />
                                  </Col>
                                  <Col
                                    xs={12}
                                    md={4}
                                    lg={4}
                                    className="commTopButtonRightLeftPadding"
                                  >
                                    <InputField
                                      className="inputBox"
                                      label="Amendment if Any"
                                      name="mouamendent"
                                      placeholder=""
                                      value={formInputs.mouamendent || ""}
                                      onChange={onInputChange}
                                      disabled={true}
                                      // error={validation.mouamendent}
                                      required={true}
                                    />
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )}
                {/* 05 Commodity / Service Details*/}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible5
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility5}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">CD</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">
                            Commodity / Service Details
                          </span>
                          <span className="subHeaderTitle">
                            Commodity and Service Description
                          </span>
                        </Col>

                        <Col xs={2} md={1} lg={1} className="">
                          <CommonFillter />
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible5 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Commodity / services offered"
                              placeholder=""
                              data={dropdownOption}
                              id="commodityServices"
                              iconClassName="dropdownIcon"
                              name="commodityServices"
                              setValue={formInputs.commodityServices || ""}
                              getvalue={setDropdownData}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 09 */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible9
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility9}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">FI</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">
                            Financial Information
                          </span>
                          <span className="subHeaderTitle">
                            Please provide your company's turnover for the last
                            2 years, supported by documentary evidence
                          </span>
                        </Col>

                        <Col xs={2} md={1} lg={1} className="">
                          <CommonFillter />
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible9 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Year 1 - Turnover  "
                              extraLabel="Year 1 - Company turnover supported by documentary evidence"
                              name="turnover1"
                              placeholder=""
                              value={formInputs.turnover1 || ""}
                              disabled={true}
                              onChange={onInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Year 2 - Turnover "
                              extraLabel="Year 2 - Company turnover supported by documentary evidence"
                              name="turnover2"
                              placeholder=""
                              value={formInputs.turnover2 || ""}
                              disabled={true}
                              onChange={onInputChange}
                            />
                          </Col>
                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding  justify-content-center align-items-center"
                            >
                              <div className="d-flex flex-column ">
                                <p className="fw-medium m-0 text-nowrap">
                                  Year 1 - Turnover
                                </p>

                                {(formInputs?.turnover1Atch && (
                                  <img
                                    src="assets/img/newIcons/attached-file.png"
                                    className="mt-1 attachmentIcon"
                                    alt="attachments"
                                    onClick={() =>
                                      handleViewFile(formInputs?.turnover1Atch)
                                    }
                                  />
                                )) ||
                                  "--"}
                              </div>
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding  justify-content-center align-items-center"
                            >
                              <div className="d-flex flex-column ">
                                <p className="fw-medium m-0 text-nowrap">
                                  Year 2 - Turnover
                                </p>

                                {(formInputs?.turnover2Atch && (
                                  <img
                                    src="assets/img/newIcons/attached-file.png"
                                    className="mt-1 attachmentIcon"
                                    alt="attachments"
                                    onClick={() =>
                                      handleViewFile(formInputs?.turnover2Atch)
                                    }
                                  />
                                )) ||
                                  "--"}
                              </div>
                            </Col>
                          </Row>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
                {/* 10 */}
                {/* <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible10
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility10}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">CD</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">
                            Company Documents & Certificates
                          </span>
                          <span className="subHeaderTitle">
                            Company Documents & Certificates details
                          </span>
                        </Col>

                        <Col xs={2} md={1} lg={1} className="">
                          <CommonFillter />
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible10 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col xs={12} md={12} lg={12}>
                            <DataTable
                              title=""
                              columns={companyDocumentsCol}
                              data={formInputs.certifications}
                              progressPending={loading}
                              paginationRowsPerPageOptions={
                                Constants.ROW_PER_PAGE
                              }
                              pagination
                              // paginationServer
                              // paginationTotalRows={totalRows}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              selectableRows
                              // onSelectedRowsChange={handleChange}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div> */}

                {/* Company Documents & Certificates*/}
               {/*  <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible10
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility10}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">CD</span>
                        </Col>

                        <Col xs={4} md={8} lg={8}>
                          <span className="headerTitle">
                            {" "}
                            Company Documents & Certificates{" "}
                          </span>
                          <span className="subHeaderTitle">
                            Company Documents & Certificates details
                          </span>
                        </Col>

                        <Col xs={1} md={1} lg={1}></Col>
                      </Row>
                    </h2>

                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible10 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <div className="accordion-body">
                              <div className="d-flex-column justify-content-center">
                                <Row>
                                  <Col xs={12}>
                                    <div className="accordion-body">
                                      <div className="d-flex-column justify-content-center">
                                        <Row className="pt-4 d-none d-md-flex">
                                          <Col md={4} lg={2}>
                                            <p className="fs-6 fw-medium d-flex justify-content-center">
                                              Document Type
                                            </p>
                                          </Col>
                                          <Col md={4} lg={2}>
                                            <p className="fs-6 fw-medium d-flex ms-4">
                                              Document Number
                                            </p>
                                          </Col>
                                          <Col md={4} lg={2}>
                                            <p className="fs-6 fw-medium d-flex ms-4">
                                              Expiration Date
                                            </p>
                                          </Col>
                                          <Col md={4} lg={2}>
                                            <p className="fs-6 fw-medium d-flex ms-3">
                                              View Files
                                            </p>
                                          </Col>
                                          <Col md={4} lg={2}>
                                            <p className="fs-6 fw-medium d-flex justify-content-center">
                                              Attachments
                                            </p>
                                          </Col>
                                        </Row>

                                        {getCertificateData?.map(
                                          (doc, index) => (
                                            <Row key={doc.id}>
                                              <Col xs={12}>
                                                <hr className="mx-4 my-0 text-color-black" />
                                              </Col>
                                              <Col
                                                xs={12}
                                                md={4}
                                                lg={2}
                                                className="commTopButtonRightLeftPadding"
                                              >
                                                <ComboboxField
                                                  label=""
                                                  placeholder="Document type"
                                                  // data={getdocumentType}
                                                  id="documentType"
                                                  iconClassName="dropdownIcon"
                                                  name="documentType"
                                                  code="documentTypeCode"
                                                  description="documentTypeDesc"
                                                  setValue={doc?.documentType}
                                                  getvalue={setDropdownData}
                                                  index={doc.id}
                                                  // onChangeValue={
                                                  //   handleInputChangeCertificate
                                                  // }
                                                />
                                              </Col>
                                              <Col
                                                xs={12}
                                                md={4}
                                                lg={2}
                                                className="commTopButtonRightLeftPadding"
                                              >
                                                <InputField
                                                  className="inputBox"
                                                  placeholder="Document Number"
                                                  value={doc.documentNumber}
                                                  // onChange={(e) =>
                                                  //   handleInputChangeCertificate(
                                                  //     doc.id,
                                                  //     "documentNumber",
                                                  //     e.target.value,
                                                  //     doc.type
                                                  //   )
                                                  // }
                                                  // error={
                                                  //   validation?.[
                                                  //     `${doc.id}_documentNumber`
                                                  //   ]
                                                  // }
                                                />
                                              </Col>
                                              <Col
                                                xs={12}
                                                md={4}
                                                lg={2}
                                                className="commTopButtonRightLeftPadding"
                                              >
                                                <InputField
                                                  className="inputBox"
                                                  type="date"
                                                  value={doc.expirationDate}
                                                  // onChange={(e) =>
                                                  //   handleInputChangeCertificate(
                                                  //     doc.id,
                                                  //     "expirationDate",
                                                  //     e.target.value
                                                  //   )
                                                  // }
                                                  disabled={true}
                                                />
                                              </Col>

                                              <Col
                                                xs={12}
                                                md={4}
                                                lg={1}
                                                className="commTopButtonRightLeftPadding"
                                              >
                                                <div className="d-flex justify-content-center">
                                                  {(doc.iSOCertification && (
                                                    <img
                                                      src="assets/img/newIcons/attached-file.png"
                                                      className="mt-1 attachmentIcon"
                                                      alt="attachments"
                                                      onClick={() =>
                                                        handleViewFile(
                                                          doc.iSOCertification
                                                        )
                                                      }
                                                    />
                                                  )) ||
                                                    "--"}
                                                </div>
                                              </Col>
                                              <Col
                                                xs={12}
                                                md={4}
                                                lg={3}
                                                className="commTopButtonRightLeftPadding"
                                              >
                                                <FileUploadComponent
                                                  id={doc.id}
                                                  name="iSOCertification"
                                                  label=""
                                                  allowedTypes={[
                                                    "image/png",
                                                    "image/jpeg",
                                                    "application/pdf",
                                                  ]}
                                                  multiple={true} // Change to `false` for single file selection
                                                  // required={true}
                                                  disabled={true}
                                                  // onSuccessUpload={
                                                  //   onSuccessUploadDocumentFileTypes
                                                  // }
                                                  value={
                                                    doc.iSOCertification || ""
                                                  }
                                                />
                                              </Col>
                                            </Row>
                                          )
                                        )}
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div> */}

                {formInputs.supplierTypeCode !== "S01" && (
                  <>
                    {/* 11 */}
                    <div className="accordion mb-4" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <Row className="accordion-button">
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-left arrowBtn"
                            >
                              <i
                                className={`bi ${
                                  isCardVisible11
                                    ? "bi-chevron-right"
                                    : "bi-chevron-down"
                                }`}
                                onClick={toggleCardVisibility11}
                              ></i>
                            </Col>
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-center logoBtn"
                            >
                              <span className="iconLogo">BM</span>
                            </Col>
                            <Col xs={12} md={9} lg={9}>
                              <span className="headerTitle">
                                Business Continuity Management
                              </span>
                              <span className="subHeaderTitle">
                                Business Continuity Management
                              </span>
                            </Col>

                            <Col xs={2} md={1} lg={1} className="">
                              <CommonFillter />
                            </Col>
                          </Row>
                        </h2>

                        <div
                          className={`accordion-collapse collapse show ${
                            isCardVisible11 ? "visible" : ""
                          }`}
                        >
                          <div className="accordion-body">
                            <Row className="pt-2 pb-4">
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Does your Company have a Business Continuity Management (BCM) Plan / Policy"
                                  placeholder=""
                                  data={dropdownOption}
                                  id="BCMPlanPolicy"
                                  iconClassName="dropdownIcon"
                                  name="BCMPlanPolicy"
                                  setValue={formInputs.BCMPlanPolicy || ""}
                                  getvalue={setDropdownData}
                                  disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                />
                                <div className="col-sm-10">
                                  <input
                                    className="form-control"
                                    type="file"
                                    id="formFile"
                                  />
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* 12 */}
                    <div className="accordion mb-4" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <Row className="accordion-button">
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-left arrowBtn"
                            >
                              <i
                                className={`bi ${
                                  isCardVisible12
                                    ? "bi-chevron-right"
                                    : "bi-chevron-down"
                                }`}
                                onClick={toggleCardVisibility12}
                              ></i>
                            </Col>
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-center logoBtn"
                            >
                              <span className="iconLogo">BI</span>
                            </Col>
                            <Col xs={12} md={9} lg={9}>
                              <span className="headerTitle">
                                Business & Brand Information
                              </span>
                              <span className="subHeaderTitle">
                                Category Specific Information
                              </span>
                            </Col>

                            <Col xs={2} md={1} lg={1} className="">
                              <CommonFillter />
                            </Col>
                          </Row>
                        </h2>

                        <div
                          className={`accordion-collapse collapse show ${
                            isCardVisible12 ? "visible" : ""
                          }`}
                        >
                          <div className="accordion-body">
                            <Row className="pt-2 pb-4">
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Dealership Set-up Type"
                                  placeholder=""
                                  data={dropdownOption}
                                  id="dealershipSetupType"
                                  iconClassName="dropdownIcon"
                                  name="dealershipSetupType"
                                  setValue={
                                    formInputs.dealershipSetupType || ""
                                  }
                                  getvalue={setDropdownData}
                                  disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="MRO commodity / category for the selected brand "
                                  placeholder=""
                                  data={dropdownOption}
                                  id="MROcommoditybrand"
                                  iconClassName="dropdownIcon"
                                  name="MROcommoditybrand"
                                  setValue={formInputs.MROcommoditybrand || ""}
                                  getvalue={setDropdownData}
                                  disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  type="text"
                                  label="Brand Name"
                                  id="brandName"
                                  name="brandName"
                                  placeholder=""
                                  value={formInputs.brandName}
                                  onChange={onInputChange}
                                  disabled={getDisabledStatus}
                                />
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* 14 */}
                    <div className="accordion mb-4" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <Row className="accordion-button">
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-left arrowBtn"
                            >
                              <i
                                className={`bi ${
                                  isCardVisible14
                                    ? "bi-chevron-right"
                                    : "bi-chevron-down"
                                }`}
                                onClick={toggleCardVisibility14}
                              ></i>
                            </Col>
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-center logoBtn"
                            >
                              <span className="iconLogo">PF</span>
                            </Col>
                            <Col xs={12} md={9} lg={9}>
                              <span className="headerTitle">
                                Pre Assessment Form
                              </span>
                              <span className="subHeaderTitle">
                                Category Specific Information
                              </span>
                            </Col>

                            <Col xs={2} md={1} lg={1} className="">
                              <CommonFillter />
                            </Col>
                          </Row>
                        </h2>

                        <div
                          className={`accordion-collapse collapse show ${
                            isCardVisible14 ? "visible" : ""
                          }`}
                        >
                          <div className="accordion-body">
                            <Row className="pt-2 pb-4">
                              <Col
                                xs={12}
                                md={3}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Do you have a building stability certificate?"
                                  placeholder=""
                                  data={dropdownOption}
                                  id="haveWrittenPolicyOnAntiCorruption"
                                  iconClassName="dropdownIcon"
                                  name="haveWrittenPolicyOnAntiCorruption"
                                  setValue={
                                    formInputs.haveWrittenPolicyOnAntiCorruption ||
                                    ""
                                  }
                                  getvalue={setDropdownData}
                                  disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={1}
                                lg={1}
                                className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                              >
                                {(formInputs?.factoryLicense && (
                                  <img
                                    src="assets/img/newIcons/attached-file.png"
                                    className="mt-1 attachmentIcon"
                                    alt="attachments"
                                    onClick={() =>
                                      handleViewFile(formInputs?.factoryLicense)
                                    }
                                  />
                                )) ||
                                  "--"}
                              </Col>
                              <Col
                                xs={12}
                                md={3}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Do you have a valid fire license/ fire safety certificates "
                                  placeholder=""
                                  data={dropdownOption}
                                  id="haveWrittenRiskAssesProcessInSc"
                                  iconClassName="dropdownIcon"
                                  name="haveWrittenRiskAssesProcessInSc"
                                  setValue={
                                    formInputs.haveWrittenRiskAssesProcessInSc ||
                                    ""
                                  }
                                  getvalue={setDropdownData}
                                  disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={1}
                                lg={1}
                                className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                              >
                                {(formInputs?.stabilityCertificate && (
                                  <img
                                    src="assets/img/newIcons/attached-file.png"
                                    className="mt-1 attachmentIcon"
                                    alt="attachments"
                                    onClick={() =>
                                      handleViewFile(
                                        formInputs?.stabilityCertificate
                                      )
                                    }
                                  />
                                )) ||
                                  "--"}
                              </Col>
                              <Col
                                xs={12}
                                md={3}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Is the current factory layout in compliance with approved factory layout"
                                  placeholder=""
                                  data={dropdownOption}
                                  id="haveWrittenCodeOfConduct"
                                  iconClassName="dropdownIcon"
                                  name="haveWrittenCodeOfConduct"
                                  setValue={
                                    formInputs.haveWrittenCodeOfConduct || ""
                                  }
                                  getvalue={setDropdownData}
                                  disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={1}
                                lg={1}
                                className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                              >
                                {(formInputs?.factoryLayout && (
                                  <img
                                    src="assets/img/newIcons/attached-file.png"
                                    className="mt-1 attachmentIcon"
                                    alt="attachments"
                                    onClick={() =>
                                      handleViewFile(formInputs?.factoryLayout)
                                    }
                                  />
                                )) ||
                                  "--"}
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <label className="form-label">
                                  Do you have a Valid Factory License?
                                  <br />
                                  a. Compliant With Approved Worker Strength.
                                  <br />
                                  b. Compliant With Approved Power
                                  Installations.
                                  <br />
                                  c. Valid for at least 45 days from the date of
                                  on-boarding / renewal applications submitted
                                  with the authority
                                </label>

                                <ComboboxField
                                  label="Is the current factory layout in compliance with approved factory layout"
                                  placeholder=""
                                  // data={dropdownOption1}
                                  id="alignedWithScComplianceEthics"
                                  iconClassName="dropdownIcon"
                                  name="alignedWithScComplianceEthics"
                                  setValue={
                                    formInputs.alignedWithScComplianceEthics ||
                                    ""
                                  }
                                  getvalue={setDropdownData}
                                  disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                />
                              </Col>
                              {(() => {
                                switch (selectedDropdownOption) {
                                  case "a":
                                    return (
                                      <>
                                        <Col
                                          xs={12}
                                          md={1}
                                          lg={1}
                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                        >
                                          {(formInputs?.docA && (
                                            <img
                                              src="assets/img/newIcons/attached-file.png"
                                              className="mt-1 attachmentIcon"
                                              alt="attachments"
                                              onClick={() =>
                                                handleViewFile(formInputs?.docA)
                                              }
                                            />
                                          )) ||
                                            "--"}
                                        </Col>
                                      </>
                                    );
                                  case "b":
                                    return (
                                      <>
                                        <Col
                                          xs={12}
                                          md={1}
                                          lg={1}
                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                        >
                                          {(formInputs?.docB && (
                                            <img
                                              src="assets/img/newIcons/attached-file.png"
                                              className="mt-1 attachmentIcon"
                                              alt="attachments"
                                              onClick={() =>
                                                handleViewFile(formInputs?.docB)
                                              }
                                            />
                                          )) ||
                                            "--"}
                                        </Col>
                                      </>
                                    );
                                  case "c":
                                    return (
                                      <>
                                        <Col
                                          xs={12}
                                          md={1}
                                          lg={1}
                                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                        >
                                          {(formInputs?.docC && (
                                            <img
                                              src="assets/img/newIcons/attached-file.png"
                                              className="mt-1 attachmentIcon"
                                              alt="attachments"
                                              onClick={() =>
                                                handleViewFile(formInputs?.docC)
                                              }
                                            />
                                          )) ||
                                            "--"}
                                        </Col>
                                      </>
                                    );
                                  default:
                                    return null;
                                }
                              })()}
                            </Row>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* 15 */}
                    {/* <div className="accordion mb-4" id="accordionExample">
                        <div className="accordion-item">
                          <h2 className="accordion-header">
                            <Row className="accordion-button">
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-left arrowBtn"
                              >
                                <i
                                  className={`bi ${isCardVisible15
                                    ? "bi-chevron-right"
                                    : "bi-chevron-down"
                                    }`}
                                  onClick={toggleCardVisibility15}
                                ></i>
                              </Col>
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-center logoBtn"
                              >
                                <span className="iconLogo">HR</span>
                              </Col>
                              <Col xs={12} md={9} lg={9}>
                                <span className="headerTitle">Human Rights</span>
                                <span className="subHeaderTitle">
                                  For which of the following working conditions
                                  and human rights issues does your company have a
                                  policy/procedure in place?
                                </span>
                              </Col>

                              <Col xs={2} md={1} lg={1} className="">
                                <CommonFillter />
                              </Col>
                            </Row>
                          </h2>

                          <div
                            className={`accordion-collapse collapse show ${isCardVisible15 ? "visible" : ""
                              }`}
                          >
                            <div className="accordion-body">
                              <Row className="pt-2 pb-4">
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Child Labour"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="ChildLabourPolicy"
                                    iconClassName="dropdownIcon"
                                    name="ChildLabourPolicy"
                                    setValue={formInputs.ChildLabourPolicy || ""}
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Working hours / Remuneration"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="WorkingHoursPolicy"
                                    iconClassName="dropdownIcon"
                                    name="WorkingHoursPolicy"
                                    setValue={formInputs.WorkingHoursPolicy || ""}
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Conflict minerals and indigenous people"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="ConflictMineralsIndigenousPeople"
                                    iconClassName="dropdownIcon"
                                    name="ConflictMineralsIndigenousPeople"
                                    setValue={
                                      formInputs.ConflictMineralsIndigenousPeople ||
                                      ""
                                    }
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Discrimination at work"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="DiscriminationAtWorkPolicy"
                                    iconClassName="dropdownIcon"
                                    name="DiscriminationAtWorkPolicy"
                                    setValue={
                                      formInputs.DiscriminationAtWorkPolicy || ""
                                    }
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Freedom of association"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="FreedomOfAssociationPolicy"
                                    iconClassName="dropdownIcon"
                                    name="FreedomOfAssociationPolicy"
                                    setValue={
                                      formInputs.FreedomOfAssociationPolicy || ""
                                    }
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Communication in a language that is fully understood by your employees"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="CommuncationFullyUnderstood"
                                    iconClassName="dropdownIcon"
                                    name="CommuncationFullyUnderstood"
                                    setValue={
                                      formInputs.CommuncationFullyUnderstood || ""
                                    }
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Forced labour"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="ForcedLabourPolicy"
                                    iconClassName="dropdownIcon"
                                    name="ForcedLabourPolicy"
                                    setValue={formInputs.ForcedLabourPolicy || ""}
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Harassment"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="HarassmentPolicy"
                                    iconClassName="dropdownIcon"
                                    name="HarassmentPolicy"
                                    setValue={formInputs.HarassmentPolicy || ""}
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </div>
                      </div> */}
                    {/* 16 */}
                    {/* 17 */}
                    {/* <div className="accordion mb-4" id="accordionExample">
                        <div className="accordion-item">
                          <h2 className="accordion-header">
                            <Row className="accordion-button">
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-left arrowBtn"
                              >
                                <i
                                  className={`bi ${isCardVisible17
                                    ? "bi-chevron-right"
                                    : "bi-chevron-down"
                                    }`}
                                  onClick={toggleCardVisibility17}
                                ></i>
                              </Col>
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-center logoBtn"
                              >
                                <span className="iconLogo">SI</span>
                              </Col>
                              <Col xs={12} md={9} lg={9}>
                                <span className="headerTitle">
                                  SAP Information
                                </span>
                                <span className="subHeaderTitle">
                                  SAP Information of Supplier
                                </span>
                              </Col>

                              <Col xs={2} md={1} lg={1} className="">
                                <CommonFillter />
                              </Col>
                            </Row>
                          </h2>

                          <div
                            className={`accordion-collapse collapse show ${isCardVisible17 ? "visible" : ""
                              }`}
                          >
                            <div className="accordion-body">
                              <Row className="pt-2 pb-4">
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="SAP ID"
                                    name="sapAssociateNumber"
                                    extraLabel="SAP Vendor ID"
                                    placeholder=""
                                    value={formInputs.sapAssociateNumber || ""}
                                    disabled={true}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Account Group"
                                    name="accountGroup"
                                    placeholder=""
                                    value={formInputs.accountGroup || ""}
                                    onChange={onInputChange}
                                    disabled={true}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Company Code"
                                    extraLabel="SAP Company Code"
                                    placeholder=""
                                    id="companyCode"
                                    iconClassName="dropdownIcon"
                                    name="companyCode"
                                    setValue={formInputs.companyCode || ""}
                                    getvalue={setDropdownData}
                                    onChange={onInputChange}
                                    disabled={getDisabledStatus}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Purchase Organization"
                                    extraLabel="SAP Purchase organization"
                                    placeholder=""
                                    id="purchaseOrg"
                                    iconClassName="dropdownIcon"
                                    name="purchaseOrg"
                                    setValue={formInputs.purchaseOrg || ""}
                                    onChange={onInputChange}
                                    disabled={getDisabledStatus}
                                  />
                                </Col>

                                <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Account Group"                          
                          name="accountGroup"
                          placeholder=""
                          value={formInputs.accountGroup || ""}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>                   
                              </Row>
                            </div>
                          </div>
                        </div>
                      </div> */}
                  </>
                )}
              </>
            )}
          </div>
        </Col>
      </Row>

      <div className="pageFooter">
        <Row className="rowDirection">
          {/* <Col xs={12} md={2} lg={2} className="">
            <button
              className="btnTable"
              onClick={handleSave}
              disabled={disabled}
            >
              <i className="bi bi-save"></i> Save
            </button>
          </Col>
          <Col xs={12} md={2} lg={2} className="">
            <button className="btnTable" onClick={handleModify}>
              <i className="bi bi-save"></i> Modify
            </button>
          </Col> */}
          {/* <Col xs={12} md={2} lg={2} className="">
            <button className="btnTable">
              <i className="bi bi-save"></i> Save as Draft
            </button>
          </Col> */}
          {/* <Col xs={12} md={2} lg={2} className="">
            <button className="btnTable">
              <i className="bi bi-save"></i> Excel Download
            </button>
          </Col> */}
        </Row>
      </div>

      <CategorySelectionModal show={modalShow} onHide={() => hideModal()} />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
    </main>
  );
};

export default VendorDetailedPage;
